var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Suspense, useCallback, useEffect, useMemo, useState, } from "react";
import { useStyles } from "./assets/style";
import "./assets/style.css"; // @ts-ignore
import { icons, sizesIcon, typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { themeCore } from "../../assets/themes/theme";
import * as catalogConst from "../../const/catalog";
import { STEP_CONFIRMATIONFORM } from "../../const/catalog";
import { formatPhoneNumber } from "../../utils/formats";
import { navigateNext, stepProgress } from "../../dataBase/stepProgress";
import { Customer } from "../../enum/customer";
import { Steps } from "../../enum/steps";
import { PostUploadDocuments } from "../../fnx/apaAuditDocuments/quoteUploadDocuments";
import { GetCatalogBeneficiary } from "../../fnx/catalog/getCatalogBeneficiary";
import { GetCatalogInsurance } from "../../fnx/catalog/getCatalogInsurance";
import { GetPaymentMode } from "../../fnx/paymentMode/getPaymentMode";
import { useCertificateQuote } from "../../fnx/certificate/certificateQuotes";
import { getCustomerAction, isAcap, isCustomer } from "../../fnx/customer";
import { GetPersonByDocument } from "../../fnx/person/getPersonByDocument";
import { showToastSuccessMessage } from "../../fnx/sendSuccessMessage";
import { formatDocument, getLogin, transformToSelect, } from "../../services/functions";
import { hasPermission } from "../../services/getNavigationPages";
import LocalStorageService from "../../services/localStorage";
import showToast from "../../services/toast";
import { postQuoteUploadDocumentClearData } from "../../store/apapUploadAttachments/actions";
import { benefitClearData, getBeneficiary, patchBeneficiaryClearData, } from "../../store/beneficiary/actions";
import { certificateQuoteClearData } from "../../store/certificates/actions";
import { countries } from "../../store/countries/actions";
import { quoteClearData, quoteOne } from "../../store/generateQuote/actions";
import { identificationType } from "../../store/identificationType/actions";
import { deleteInsured as deleteInsuredAction, deleteInsuredClearData, insured, patchInsuredClearData, postInsuredClearData, } from "../../store/insured/actions";
import { pageActionFlagsClearData } from "../../store/pageActionFlags/actions";
import { personByDocumentClearData, updatePersonClearData, } from "../../store/person/actions";
import { catalogGender } from "../../store/plan/actions";
import { plans } from "../../store/plans/actions";
import { projectOne, projectOneClearData } from "../../store/project/actions";
import { region } from "../../store/region/actions";
import { Branches } from "../../store/branches/actions";
import { patchQuoteClearData } from "../../store/updateQuote/actions";
import { patchQuoteAPI } from "../../resources/helper/updateQuote";
import { formattedDate, formattedDateTime, newFormattedDate, } from "../../utils/date";
import { formatNumberCustom, formatToTwoDecimals, parsePrice, } from "../../utils/getPrice";
import { AdditionalDocumentationColumns, dataEditVehicleForm, rowsClientDocument, StatementColumns, Tab1Columns, Tab2Columns, Tab3Columns, Tab4Columns, TabAppointmentColumns, TabAppointmentManagerColumns, TabAutoColumns, TabCardInfoColumns, } from "./resources/confirmationFormDto";
import { ConfirmationFormView } from "./ui/view"; /* Beneficiary */
import useBeneficiary from "./components/beneficiary"; /* Insurance */
import useInsurance from "./components/insurance"; /* Vehicle */
import useVehicle from "./components/vehicle"; /* ConfirmationForm */
import useClient from "./components/client"; /* Form Actions */
import useActions from "./components/ui"; /* Selectors */
import useSelectors from "./components/selectors"; /* Functions */
import useFunctions from "./components/functions";
import { PassengerDownloadModal } from "./resources/PassengerDownloadModal";
import PagesHeader from "ah_utility/PagesHeader";
import { useGetSteps } from "../../utils/getSteps";
import { findParamInLocalStorage } from "../../utils/getAnyDataLocalStorge";
import { ConfirmationHeader } from "./header";
import { addStepInformationToAllSteps, useGetInformationSteps, } from "ah_utility/workflow";
import { useGetSummary } from "../../utils/getSummary";
import { useStepNavigation } from "ah_utility/NavigationEngine";
import { formAddBusiness } from "./resources/FormsBusinessDTO";
import { useCatalogues } from "../addBusiness/hooks/useCatalogues";
import { useStartWokFlow } from "../../fnx/workFlow/startWorkFlow";
import { startWorkFlowClearData } from "../../store/workFlow/actions";
import { policyConfirm, policyConfirmClearData, } from "../../store/policy/actions";
import { addToSummary, getFlagValue } from "ah_utility/fnxUtils";
import usePaymentConfirmation from "../paymentConfirmation/components/paymentConfirmation";
import { useErrorHandling } from "./hooks/useErrorHandling";
import { useAppointment } from "./hooks/useAppointment";
import { useAppointmentManager } from "./hooks/useAppointmentManager";
import { useQuoteComments } from "./hooks/useQuoteComments";
import { useAuditLogs } from "./hooks/useAuditLogs";
import { useMailHistory } from "./hooks/useMailHistory";
var STEP = STEP_CONFIRMATIONFORM;
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
var storageKey3 = "afy-action-flags";
var lsPageActionFlags = new LocalStorageService(storageKey3);
var storageKey4 = "afy-steps";
var lsSteps = new LocalStorageService(storageKey4);
var ConfirmationForm = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15;
    var permissions = {
        create: hasPermission("sale-confirmation-form-create"),
    };
    // -- DATA & STATES BUSINESS HOME
    var _16 = React.useState(false), openModalAddBusiness = _16[0], setOpenModalAddBusiness = _16[1];
    var _17 = React.useState(false), showTabRealEstates = _17[0], setShowTabRealEstates = _17[1];
    var _18 = useState(formAddBusiness), dataFormBusiness = _18[0], setDataFormBusiness = _18[1];
    var _19 = React.useState(false), isCommerce = _19[0], setIsCommerce = _19[1];
    var _20 = useState(""), provinceId = _20[0], setProvinceId = _20[1];
    var _21 = useState(""), townId = _21[0], setTowId = _21[1];
    var _22 = useState(""), sectorId = _22[0], setSectorId = _22[1];
    var _23 = useState(""), planCode = _23[0], setPlanCode = _23[1];
    var _24 = useState(""), productCode = _24[0], setProductCode = _24[1];
    var _25 = useState([]), rowsProperties = _25[0], setRowsProperties = _25[1];
    var _26 = useState(""), propertyTypeId = _26[0], setPropertyTypeId = _26[1];
    var _27 = React.useState(""), damageBackup = _27[0], setDamageBackup = _27[1];
    var _28 = React.useState(""), insuredProperty = _28[0], setInsuredProperty = _28[1];
    // HOME
    var _29 = React.useState(false), openModalAddHome = _29[0], setOpenModalAddHome = _29[1];
    var _30 = React.useState(false), showFormBusiness = _30[0], setShowFormBusiness = _30[1];
    // -- END DATA & STATES BUSINESS HOME
    //APPOINMENT
    var _31 = React.useState(false), showTabAppointment = _31[0], setShowTabAppointment = _31[1];
    var _32 = React.useState(false), showTabAppointmentManager = _32[0], setShowTabAppointmentManager = _32[1];
    var _33 = React.useState(true), addAppointmentAction = _33[0], setAddAppointmentAction = _33[1];
    var _34 = React.useState(false), openModalAddAppointmentAction = _34[0], setOpenModalAddAppointmentAction = _34[1];
    var t = useTranslation().t;
    var classes = useStyles();
    var storageKey = "afy-steps";
    var localStorageService = new LocalStorageService(storageKey);
    var clientId = React.useState(lsLogin.getUserLoginStored().clientId)[0];
    var _35 = React.useState(lsPageActionFlags.getPageActionFlagsStored()), actionFlags = _35[0], setActionFlags = _35[1];
    var afy_label_premium = (_a = actionFlags.find(function (x) { return x.name === "afy-label-summary-premium"; })) === null || _a === void 0 ? void 0 : _a.value;
    var afy_premium_always_visible = (_b = actionFlags.find(function (x) { return x.name === "afy-confirm-data-premium-always-visible"; })) === null || _b === void 0 ? void 0 : _b.value;
    var afy_currency = (_c = actionFlags.find(function (x) { return x.name === "afy-plan-currency"; })) === null || _c === void 0 ? void 0 : _c.value;
    var _36 = useState(""), planId = _36[0], setPlanId = _36[1];
    var _37 = React.useState(false), openDrawerUpload = _37[0], setOpenDrawerUpload = _37[1];
    var _38 = React.useState(""), idDocumentClient = _38[0], setIdDocumentClient = _38[1];
    var _39 = useState(""), coverTypeId = _39[0], setCoverTypeId = _39[1];
    var _40 = useState(""), campaignId = _40[0], setCampaignId = _40[1];
    var _41 = useState(""), catalogPaymentMode = _41[0], setCatalogPaymentMode = _41[1];
    var _42 = useState(""), catalogStatusQuote = _42[0], setCatalogStatusQuote = _42[1];
    var _43 = useState(""), policyStatus = _43[0], setPolicyStatus = _43[1];
    var _44 = useState([]), paymentMethodCardData = _44[0], setPaymentMethodCardData = _44[1];
    var _45 = useState(""), branchId = _45[0], setBranchId = _45[1];
    var userId = React.useState(lsLogin.getUserLoginStored().clientId)[0];
    var _46 = React.useState(false), uploadTrigger = _46[0], setUploadTrigger = _46[1];
    var isVidaTermino = isCustomer(Customer.VIDA);
    var _47 = React.useState(""), period = _47[0], setPeriod = _47[1];
    var _48 = React.useState([]), breadCrumbs = _48[0], setBreadCrumbs = _48[1];
    var _49 = React.useState(false), showInsured = _49[0], setShowInsured = _49[1];
    var _50 = React.useState(false), showNewFormInsurance = _50[0], setShowNewFormInsurance = _50[1];
    var _51 = React.useState(false), showBeneficiary = _51[0], setShowBeneficiary = _51[1];
    var _52 = React.useState(true), addInsured = _52[0], setAddInsured = _52[1];
    var _53 = React.useState(true), addBeneficiary = _53[0], setAddBeneficiary = _53[1];
    var _54 = React.useState(false), showComponent = _54[0], setShowComponent = _54[1];
    var _55 = useState(false), openModalBackConfirm = _55[0], setOpenModalBackConfirm = _55[1];
    var _56 = React.useState(true), canEdit = _56[0], setCanEdit = _56[1];
    var _57 = React.useState(false), showDownloads = _57[0], setShowDownloads = _57[1];
    var _58 = React.useState(false), canEditLocation = _58[0], setCanEditLocation = _58[1];
    var _59 = React.useState(false), canEditContact = _59[0], setCanEditContact = _59[1];
    var _60 = React.useState([]), certificates = _60[0], setCertificates = _60[1];
    var _61 = useState([]), rows = _61[0], setRows = _61[1];
    var _62 = useState([]), rows2 = _62[0], setRows2 = _62[1];
    var _63 = useState([]), rowsCardInfo = _63[0], setRowsCardInfo = _63[1];
    var _64 = useState([]), rowsBeneficiary = _64[0], setRowsBeneficiary = _64[1];
    var _65 = useState([]), rowsPassengers = _65[0], setRowsPassengers = _65[1];
    var _66 = React.useState(false), openActivePolicy = _66[0], setOpenActivePolicy = _66[1];
    var activatePolicy = useParams().activatePolicy;
    var showButtonActivatePolicy = React.useState(!!activatePolicy)[0];
    var _67 = React.useState(""), policyId = _67[0], setPolicyId = _67[1];
    var _68 = React.useState(false), hideMarriedName = _68[0], setHideMarriedName = _68[1];
    var _69 = React.useState(""), namePlan = _69[0], setNamePlan = _69[1];
    var _70 = useState(false), isMaskedDocument = _70[0], setIsMaskedDocument = _70[1];
    var _71 = useState(""), personQuoteId = _71[0], setPersonQuoteId = _71[1];
    var _72 = useState(""), prime = _72[0], setPrime = _72[1];
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var _73 = React.useState(true), enable = _73[0], setEnable = _73[1];
    var _74 = React.useState([]), listIdentificationType = _74[0], setListIdentificationType = _74[1];
    var _75 = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _75[0], setSeeToast = _75[1];
    var id = useParams().id;
    var isQuote = useParams().isQuote;
    var isPlan = useParams().isPlan;
    var idProject = useParams().idProject;
    var isDocumentClient = useParams().isDocumentClient;
    var _76 = React.useState(false), projectTrigger = _76[0], setProjectTrigger = _76[1];
    var _77 = React.useState(false), triggerCatalog = _77[0], setTriggerCatalog = _77[1];
    var _78 = React.useState(false), triggerCatalogInsurance = _78[0], setTriggerCatalogInsurance = _78[1];
    var _79 = React.useState(false), triggerPaymentMode = _79[0], setTriggerPaymentMode = _79[1];
    var _80 = React.useState(false), triggerCertificate = _80[0], setTriggerCertificate = _80[1];
    var _81 = useState([]), listGenders = _81[0], setListGenders = _81[1];
    var _82 = useState(isQuote === "true"), isQuoteType = _82[0], setIsQuoteType = _82[1];
    var _83 = useState(true), canEditBeneficiary = _83[0], setCanEditBeneficiary = _83[1];
    var _84 = useState(true), canEditInsured = _84[0], setCanEditInsured = _84[1];
    var _85 = useState([]), listCountries = _85[0], setListCountries = _85[1];
    var _86 = useState([]), listRegionLevel1 = _86[0], setListRegionLevel1 = _86[1];
    var _87 = useState([]), listRegionLevel2 = _87[0], setListRegionLevel2 = _87[1];
    var _88 = useState([]), listRegionLevel3 = _88[0], setListRegionLevel3 = _88[1];
    var _89 = React.useState(1), page = _89[0], setPage = _89[1];
    var _90 = React.useState(""), idQuoteVehicle = _90[0], setIdQuoteVehicle = _90[1];
    var _91 = React.useState(""), productId = _91[0], setProductId = _91[1];
    var _92 = React.useState(10000), limit = _92[0], setLimit = _92[1];
    var _93 = React.useState(false), openModal = _93[0], setOpenModal = _93[1];
    var _94 = React.useState(false), openModalAddInsurance = _94[0], setOpenModalAddInsurance = _94[1];
    var _95 = React.useState(false), openModalPdfViewer = _95[0], setopenModalPdfViewer = _95[1];
    var _96 = React.useState(""), urlDocument = _96[0], setUrlDocument = _96[1];
    var _97 = React.useState(""), nameDocument = _97[0], setNameDocument = _97[1];
    var _98 = React.useState(""), personId = _98[0], setPersonId = _98[1];
    var _99 = React.useState(false), openModalBeneficiary = _99[0], setOpenModalBeneficiary = _99[1];
    var _100 = React.useState(transformToSelect(localStorageService.getStepStored().steps[Steps.plan].paymentMode)), paymentMode = _100[0], setPaymentMode = _100[1];
    var _101 = React.useState([
        { id: 1, name: "Sin datos", value: "-1" },
    ]), coverageType = _101[0], setCoverageType = _101[1];
    var _102 = React.useState([
        { id: 1, name: "Sin datos", value: "-1", code: "" },
    ]), insuredType = _102[0], setInsuredType = _102[1];
    var _103 = React.useState([
        { id: 1, name: "Sin datos", value: "-1" },
    ]), beneficiaryType = _103[0], setBeneficiaryType = _103[1];
    var _104 = React.useState(findParamInLocalStorage("campaign", "steps")), campaign = _104[0], setCampaign = _104[1];
    var _105 = React.useState(findParamInLocalStorage("campaign", "steps")), campaigns = _105[0], setCampaigns = _105[1];
    var _106 = React.useState(""), planName = _106[0], setPlanName = _106[1];
    var _107 = React.useState({
        id: "",
        name: "",
        value: "",
    }), campaignSelected = _107[0], setCampaignSelected = _107[1];
    var _108 = React.useState({
        id: "",
        name: "",
    }), plan = _108[0], setPlan = _108[1];
    var _109 = React.useState(false), openModalEditVehicle = _109[0], setOpenModalEditVehicle = _109[1];
    var steps = useGetSteps();
    var _110 = React.useState({
        titlePage: "Plan",
        viewType: "2",
        titleMetaTag: "Affinity Plan",
        informationPage: {
            backgroundColor: themeCore.colors.background,
            colorText: themeCore.colors.secondaryText,
            description: "Seleccion el plan que necesite el cliente",
            icon: icons.Help,
            iconSize: sizesIcon.standard,
            iconColor: themeCore.colors.primary,
        },
        filter: {
            backgroundColor: "#FFFFFF",
            bgChipInsurers: "#fff",
            bgChipInsurersSelected: "#EBEEF6",
            bgColorButton: "#fff",
            bgColorComparativeButton: "#3A56A1",
            bgColorIconButton: "#EBEEF6",
            bgColorIconButtonSelected: "#3A56A1",
            colorIconButton: "#3A56A1",
            colorIconButtonSelected: "#fff",
            colorIconChip: "#3A56A1",
            colorText: "#3A56A1",
            comparativeTextButton: "ver comparativa",
            comparativeTextColor: "#fff",
            insurers: [],
            title: "Patrocinador",
            titleFirstChip: "Todas",
        },
        data: [],
    }), planData = _110[0], setPlanData = _110[1];
    var _111 = React.useState(localStorageService.getStepStored().steps[Steps.insurance].campaign), campaignInfo = _111[0], setCampaignInfo = _111[1];
    var level1 = "REGION_LEVEL1";
    var level2 = "REGION_LEVEL2";
    var level3 = "REGION_LEVEL3";
    var _112 = React.useState(), coverType = _112[0], setCoverType = _112[1];
    var _113 = useState("Confirmación de Datos"), titleInsured = _113[0], setTitleInsured = _113[1];
    var _114 = useState("Ingresar beneficiario"), titleBeneficiary = _114[0], setTitleBeneficiary = _114[1];
    var _115 = React.useState(findParamInLocalStorage("projectId") || ""), projectId = _115[0], setProjectId = _115[1];
    var _116 = React.useState(false), isTravelInsurance = _116[0], setIsTravelInsurance = _116[1];
    // Get passenger counts from localStorage and calculate sum
    var edad020 = parseInt(findParamInLocalStorage("edad020") || "0");
    var edad2174 = parseInt(findParamInLocalStorage("edad2174") || "0");
    var edad7585 = parseInt(findParamInLocalStorage("edad7585") || "0");
    var _117 = React.useState(edad020 + edad2174 + edad7585), premiumSum = _117[0], setPremiumSum = _117[1];
    var _118 = useState(false), isUpdate = _118[0], setIsUpdate = _118[1];
    var _119 = React.useState(dataEditVehicleForm), dataFormVehicle = _119[0], setDataFormVehicle = _119[1];
    var _120 = useState({
        DocumentNumber: "",
        QuoteNumber: "",
        policeNumber: "",
        QuoteStatusName: "",
        QuoteDate: "",
        Type: "",
        PlanTypeName: "",
        CampaignName: "-",
        IdTypeName: "",
        Name: "",
        SecondName: "",
        FirstLastName: "",
        SecondLastName: "",
        MarriedSurName: "-",
        Gender: "",
        Birthday: "",
        Address1: "-",
        Address2: "-",
        CountryName: "",
        ProvinceName: "",
        TownName: "",
        SectorName: "",
        PostalCode: "",
        PhoneOffice: "",
        PhoneHome: "-",
        PhoneNumber: "-",
        Email: "",
    }), dataForm = _120[0], setDataForm = _120[1];
    var _121 = useState({
        Id: "",
        IdType: "",
        idTypeInsured: "",
        Percentage: "",
        DocumentNumber: "",
        Name: "",
        LastNameA: "",
        LastNameB: "",
        marriedName: "",
        Birthday: "",
        PhoneNumber: "",
        IdTypeName: "",
    }), dataFormBeneficiary = _121[0], setDataFormBeneficiary = _121[1];
    var _122 = useState({
        Id: "",
        IdType: "",
        idInsuredType: "",
        DocumentNumber: "",
        Name: "",
        LastNameA: "",
        LastNameB: "",
        marriedName: "",
        Birthday: "",
        PhoneNumber: "",
        IdTypeName: "",
    }), dataFormInsurance = _122[0], setDataFormInsurance = _122[1];
    var _123 = useState({
        idType: "",
        documentNumber: "",
        idInsuredType: "",
        firstName: "",
        secondName: "",
        lastNameA: "",
        lastNameB: "",
        birthday: "",
        gender: "",
        marriedName: "",
        country: "",
        province: "",
        town: "",
        sector: "",
        postalCode: "",
        address1: "",
        phoneHome: "",
        phoneNumber: "",
        phoneOffice: "",
        email: "",
    }), dataFormInsuranceSp = _123[0], setDataFormInsuranceSp = _123[1];
    var _124 = useState(""), insuranceType = _124[0], setInsuranceType = _124[1];
    var _125 = useState(45), initialPercentage = _125[0], setInitialPercentage = _125[1];
    var _126 = useState(false), trigger = _126[0], setTrigger = _126[1];
    var _127 = useState(), document = _127[0], setDocument = _127[1];
    var _128 = useState(false), isInsurance = _128[0], setIsInsurance = _128[1];
    var _129 = useState([]), listVehiclesDetail = _129[0], setListVehicles = _129[1];
    var _130 = React.useState({}), salesFlow = _130[0], setSalesFlow = _130[1];
    var _131 = React.useState([]), statementRows = _131[0], setStatementRows = _131[1];
    var _132 = React.useState([]), filters = _132[0], setFilters = _132[1];
    var _133 = React.useState([]), defaultFilters = _133[0], setDefaultFilters = _133[1];
    var _134 = React.useState(rowsClientDocument), profileDocumentsRows = _134[0], setProfileDocumentsRows = _134[1];
    var _135 = React.useState(0), countBadge = _135[0], setCountBadge = _135[1];
    var carDetails = React.useState((_d = lsSteps.getStepStored().steps[Steps.vehiclesDetails]) === null || _d === void 0 ? void 0 : _d.vehiclesDetails)[0];
    var company = React.useState(lsLogin.getUserLoginStored().subdomain || "")[0];
    var isApapAuto = getCustomerAction().customerAuto.includes(company);
    var isAcapCompany = isAcap(company);
    var _136 = useState(true), hideTabDocumentClient = _136[0], setHideTabDocumentClient = _136[1];
    var _137 = useState(true), hideTabPaymentInfo = _137[0], setHideTabPaymentInfo = _137[1];
    var isNotQuote = isQuote !== "false";
    var isApapAutoWithoutQuote = isApapAuto && !isNotQuote;
    var _138 = React.useState(""), fileName = _138[0], setFileName = _138[1];
    var _139 = React.useState(), pdfFile = _139[0], setPdfFile = _139[1];
    var _140 = React.useState(false), modalDocumentClient = _140[0], setModalDocumentClient = _140[1];
    var _141 = React.useState(""), urlDocumentClient = _141[0], setUrlDocumentClient = _141[1];
    var _142 = React.useState("false"), docName = _142[0], setDocName = _142[1];
    var _143 = React.useState(false), openModalPassenger = _143[0], setOpenModalPassenger = _143[1];
    var _144 = React.useState(""), urlDocumentPassenger = _144[0], setUrlDocumentPassenger = _144[1];
    var _145 = React.useState(""), nameDocumentPassenger = _145[0], setNameDocumentPassenger = _145[1];
    var _146 = React.useState(((_e = localStorageService.getStepStored().steps[Steps.customer]) === null || _e === void 0 ? void 0 : _e.paymentModeSelected) || { id: "", name: "", value: "" }), paymentModelSelected = _146[0], setPaymentModelSelected = _146[1];
    var _147 = React.useState(localStorageService.getStepStored().steps[Steps.customer].coverType), coverTypeSelected = _147[0], setCoverTypeSelected = _147[1];
    var _148 = useState(""), productType = _148[0], setProductType = _148[1];
    var projectTypeLocal = React.useRef((_g = (_f = lsSteps.getStepStored().steps[Steps.insurance].flow) === null || _f === void 0 ? void 0 : _f.metadata) === null || _g === void 0 ? void 0 : _g.navigation.productType);
    var didMountRef = React.useRef(false);
    var _149 = useState(""), quoteId = _149[0], setQuoteId = _149[1];
    var isApap = getCustomerAction().customerAuto.includes(company);
    var Quote = React.useState(findParamInLocalStorage("Quote"))[0];
    var quoteIdLS = Quote === null || Quote === void 0 ? void 0 : Quote.id;
    var summary = useGetSummary();
    var pathname = useLocation().pathname;
    var pathLocation = "/" + pathname.split("/")[1];
    var _150 = React.useState({}), sessionData = _150[0], setSessionData = _150[1];
    var _151 = React.useState(false), triggerStart = _151[0], setTriggerStart = _151[1];
    var workFlow = localStorage.getItem("WorkFlowId");
    var _152 = useState(""), instanceIdR = _152[0], setInstanceIdR = _152[1];
    var _153 = useState(""), currentStepId = _153[0], setCurrentStepId = _153[1];
    var _154 = React.useState(""), email = _154[0], setEmail = _154[1];
    var _155 = useState(""), nextStepId = _155[0], setNextStepId = _155[1];
    // ✅ Flag para refrescar la información de los pasos
    var _156 = useState(0), refreshStepsInfo = _156[0], setRefreshStepsInfo = _156[1];
    var _157 = React.useState([]), referrerRows = _157[0], setReferrerRows = _157[1];
    var _158 = useStepNavigation({
        currentStepId: pathLocation,
        sessionData: sessionData,
        autoValidate: true,
    }), navigation = _158.navigation, isLastPage = _158.isLastPage;
    var showCardInformation = getFlagValue("afy-confirm-data-show-card-information");
    var showDocumentClient = useState(function () { return getFlagValue("afy-isVidaActiva"); })[0];
    // ✅ Ahora pasa el refreshTrigger para recargar cuando cambie
    var _159 = useGetInformationSteps(pathLocation, { refreshTrigger: refreshStepsInfo }), instanceId = _159.instanceId, workFlowId = _159.workFlowId, currentStep = _159.currentStep, nextStep = _159.nextStep;
    // Ref para controlar si ya se inicializó el país una vez
    var countryInitializedRef = React.useRef(false);
    var actionFlagsFound = findParamInLocalStorage("", "afy-action-flags");
    var flagFound = actionFlagsFound === null || actionFlagsFound === void 0 ? void 0 : actionFlagsFound.find(function (flag) { return flag.name === "afy-confirm-filter-insurances-by-plan"; });
    var flagFilterInsuranceTypeByPlan = (flagFound === null || flagFound === void 0 ? void 0 : flagFound.value) === "true";
    var shouldFilterByCoverType = coverTypeId === "43430f8b-8fe3-4582-8d11-6f9edf69bb9e" &&
        flagFilterInsuranceTypeByPlan;
    var planIdForCatalog = shouldFilterByCoverType ? planId : undefined;
    var _160 = useState([]), downloadsStatusDenyList = _160[0], setDownloadsStatusDenyList = _160[1];
    var _161 = useState([]), showTabPaymentStatusAllowList = _161[0], setShowTabPaymentStatusAllowList = _161[1];
    var _162 = useState(false), isThereTabPaymentStatusAllowList = _162[0], setIsThereShowTabPaymentStatusAllowList = _162[1];
    var showComments = true;
    var showLogsInfo = true;
    var showTabReferrer = (_h = actionFlags === null || actionFlags === void 0 ? void 0 : actionFlags.some(function (f) {
        return f.name === "afy-confirm-data-show-tab-referrer" && f.value === "true";
    })) !== null && _h !== void 0 ? _h : false;
    var hideChangeButton = (_j = actionFlags === null || actionFlags === void 0 ? void 0 : actionFlags.some(function (f) { return f.name === "afy-do-not-change-policy" && f.value === "true"; })) !== null && _j !== void 0 ? _j : false;
    var sendProductCode = (_k = actionFlags === null || actionFlags === void 0 ? void 0 : actionFlags.some(function (f) {
        return f.name === "afy-confirm-send-productCode" && f.value === "true";
    })) !== null && _k !== void 0 ? _k : false;
    var _163 = React.useState([]), holidays = _163[0], setHolidays = _163[1];
    var _164 = React.useState(""), rolAsesorid = _164[0], setRolAsesorId = _164[1];
    var _165 = useSelectors(), loadingUpdateQuote = _165.loadingUpdateQuote, errorUpdateQuote = _165.errorUpdateQuote, responseIdentificationType = _165.responseIdentificationType, errorIdentificationType = _165.errorIdentificationType, responseCatalogGender = _165.responseCatalogGender, errorCatalogGender = _165.errorCatalogGender, responsePlan = _165.responsePlan, errorPlan = _165.errorPlan, loading = _165.loading, responseCountries = _165.responseCountries, errorCountries = _165.errorCountries, responseRegion = _165.responseRegion, errorRegion = _165.errorRegion, responsePlans = _165.responsePlans, errorPlans = _165.errorPlans, loadingPlans = _165.loadingPlans, responseInsured = _165.responseInsured, errorInsured = _165.errorInsured, responseDeleteInsured = _165.responseDeleteInsured, errorDeleteInsured = _165.errorDeleteInsured, loadingDeleteInsured = _165.loadingDeleteInsured, responsePostInsured = _165.responsePostInsured, errorPostInsured = _165.errorPostInsured, loadingPostInsured = _165.loadingPostInsured, responsePatchInsured = _165.responsePatchInsured, errorPatchInsured = _165.errorPatchInsured, loadingPatchInsured = _165.loadingPatchInsured, responseUpdatePerson = _165.responseUpdatePerson, errorUpdatePerson = _165.errorUpdatePerson, loadingUpdatePerson = _165.loadingUpdatePerson, responseBenefit = _165.responseBenefit, errorBenefit = _165.errorBenefit, loadingBenefit = _165.loadingBenefit, responsePatchBeneficiary = _165.responsePatchBeneficiary, errorPatchBeneficiary = _165.errorPatchBeneficiary, loadingPatchBeneficiary = _165.loadingPatchBeneficiary, responseBeneficiary = _165.responseBeneficiary, errorBeneficiary = _165.errorBeneficiary, loadingBeneficiary = _165.loadingBeneficiary, responsePageActionFlags = _165.responsePageActionFlags, responseOneProject = _165.responseOneProject, loadingOneProject = _165.loadingOneProject, errorOneQuote = _165.errorOneQuote, responseOneQuote = _165.responseOneQuote, loadingOneQuote = _165.loadingOneQuote, loadingInsured = _165.loadingInsured, responsePatchQuote = _165.responsePatchQuote, errorPatchQuote = _165.errorPatchQuote, loadingPatchQuote = _165.loadingPatchQuote, responsePolicyConfirmLoading = _165.responsePolicyConfirmLoading, responsePolicyConfirm = _165.responsePolicyConfirm, responsePolicyConfirmError = _165.responsePolicyConfirmError;
    var updateVehicle = useVehicle(setOpenModalEditVehicle).updateVehicle;
    var _166 = useClient(paymentMode, setPeriod, setPaymentModelSelected, setPaymentMode, paymentModelSelected, coverTypeSelected, plans, enable, page, limit, projectId, namePlan, clientId, setCoverTypeSelected, campaigns, setCampaignSelected, level2, level3, setListRegionLevel3, listGenders, setHideMarriedName, setCoverType, setPlan, campaignSelected, personQuoteId, hideMarriedName, salesFlow, setCampaign, setCampaigns, setFileName, setPdfFile, setUploadTrigger, actionFlags, isQuote, setShowInsured, setAddInsured, setShowBeneficiary, setAddBeneficiary, setCanEditInsured, setCanEditBeneficiary, responseOneQuote, setTriggerCertificate, setUrlDocument, setopenModalPdfViewer, catalogPaymentMode, setDataForm, setDefaultFilters, setPrime, dataForm, setShowNewFormInsurance, setShowTabRealEstates, setShowFormBusiness, setShowTabAppointment, setShowTabAppointmentManager, (_l = id !== null && id !== void 0 ? id : quoteId) !== null && _l !== void 0 ? _l : "", userId), searchPerson = _166.searchPerson, handleSearch = _166.handleSearch, callDispatchPlan = _166.callDispatchPlan, callDispatchPlanAfterQuoteLoaded = _166.callDispatchPlanAfterQuoteLoaded, handleOnChangePaymentMethod = _166.handleOnChangePaymentMethod, handleOnChangeCoverType = _166.handleOnChangeCoverType, handleOnChangeCampaign = _166.handleOnChangeCampaign, handleChangeSelect = _166.handleChangeSelect, handleChangeSelectFormInsurance = _166.handleChangeSelectFormInsurance, handleUpdatePerson = _166.handleUpdatePerson, handleDownload = _166.handleDownload, updateDataFormPerson = _166.updateDataFormPerson, setCoverTypeStorybook = _166.setCoverTypeStorybook, handleOnClickAcquire = _166.handleOnClickAcquire, quoteUploadDocuments = _166.quoteUploadDocuments, callQuoteOne = _166.callQuoteOne, getActionFlags = _166.getActionFlags, handleOnClickAutoDownload = _166.handleOnClickAutoDownload, handleOnClickAutoDownloadVida = _166.handleOnClickAutoDownloadVida, setLocalStorage = _166.setLocalStorage, callDispatchPageActionFlags = _166.callDispatchPageActionFlags, showVehicleData = _166.showVehicleData, showDownloadQuote = _166.showDownloadQuote, showDownloadRequest = _166.showDownloadRequest;
    var branchesData = useSelector(function (state) { var _a, _b; return (_b = (_a = state.Branches) === null || _a === void 0 ? void 0 : _a.responseBranches) === null || _b === void 0 ? void 0 : _b.data; });
    var loadingBranches = useSelector(function (state) { var _a; return (_a = state.Branches) === null || _a === void 0 ? void 0 : _a.loadingBranches; });
    useEffect(function () {
        if (clientId) {
            dispatch(Branches({
                enable: true,
                page: 1,
                limit: 100,
                clientId: clientId,
            }));
        }
    }, [clientId, dispatch]);
    var branchSwitcherOptions = useMemo(function () {
        var _a;
        var mapBranch = function (b) { return ({
            id: b.id,
            name: "".concat(b.code, " - ").concat(b.name),
            value: b.id,
        }); };
        if (Array.isArray(branchesData) && branchesData.length > 0) {
            return branchesData.map(mapBranch);
        }
        var q = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data;
        var bd = q === null || q === void 0 ? void 0 : q.branchData;
        if ((q === null || q === void 0 ? void 0 : q.branch) && bd && (bd.name != null || bd.code != null)) {
            return [
                {
                    id: q.branch,
                    name: bd.code != null && bd.name
                        ? "".concat(bd.code, " - ").concat(bd.name)
                        : bd.name || String((_a = bd.code) !== null && _a !== void 0 ? _a : ""),
                    value: q.branch,
                },
            ];
        }
        return [];
    }, [branchesData, responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data]);
    var branchDisplayLabelForSwitcher = (_p = (_o = (_m = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _m === void 0 ? void 0 : _m.branchData) === null || _o === void 0 ? void 0 : _o.name) !== null && _p !== void 0 ? _p : "";
    var _167 = useMailHistory({
        policyId: policyId,
        setSeeToast: setSeeToast,
        t: t,
    }), mailHistoryItems = _167.mailHistoryItems, mailHistoryLogCertificate = _167.mailHistoryLogCertificate, loadingMailHistory = _167.loadingMailHistory, downloadMailHistory = _167.downloadMailHistory, refetchMailHistory = _167.refetchMailHistory;
    var mailHistoryCertificate = (_t = (_s = (_r = (_q = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _q === void 0 ? void 0 : _q.policyId) === null || _r === void 0 ? void 0 : _r.code) !== null && _s !== void 0 ? _s : mailHistoryLogCertificate) !== null && _t !== void 0 ? _t : "";
    var mailHistoryPrintedAt = formattedDateTime(new Date().toISOString());
    var handleBranchChange = useCallback(function (newBranchId) { return __awaiter(void 0, void 0, void 0, function () {
        var currentQuote, effectiveQuoteId, planIdBody, coverTypeIdBody, campaignIdBody, catalogPaymentModeBody, catalogStatusQuoteBody, _a;
        var _b, _c, _d, _e, _f, _g;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    currentQuote = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data;
                    effectiveQuoteId = id !== null && id !== void 0 ? id : quoteId;
                    if (!currentQuote ||
                        !effectiveQuoteId ||
                        !userId ||
                        !((_b = currentQuote.catalogStatusQuote) === null || _b === void 0 ? void 0 : _b.id)) {
                        return [2 /*return*/];
                    }
                    planIdBody = (_c = currentQuote.planId) === null || _c === void 0 ? void 0 : _c.id;
                    coverTypeIdBody = (_d = currentQuote.coverType) === null || _d === void 0 ? void 0 : _d.id;
                    campaignIdBody = (_e = currentQuote.campaignId) === null || _e === void 0 ? void 0 : _e.id;
                    catalogPaymentModeBody = (_f = currentQuote.catalogPaymentMode) === null || _f === void 0 ? void 0 : _f.id;
                    catalogStatusQuoteBody = (_g = currentQuote.catalogStatusQuote) === null || _g === void 0 ? void 0 : _g.id;
                    if (!planIdBody ||
                        !coverTypeIdBody ||
                        !campaignIdBody ||
                        !catalogPaymentModeBody ||
                        !catalogStatusQuoteBody) {
                        return [2 /*return*/];
                    }
                    _h.label = 1;
                case 1:
                    _h.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, patchQuoteAPI({
                            planId: planIdBody,
                            coverTypeId: coverTypeIdBody,
                            campaignId: campaignIdBody,
                            catalogPaymentMode: catalogPaymentModeBody,
                            catalogStatusQuote: catalogStatusQuoteBody,
                            branchId: newBranchId,
                            userId: userId,
                        }, effectiveQuoteId)];
                case 2:
                    _h.sent();
                    callQuoteOne(effectiveQuoteId);
                    showToastSuccessMessage("Sucursal actualizada.", typeAlert.success, setSeeToast);
                    return [3 /*break*/, 4];
                case 3:
                    _a = _h.sent();
                    showToastSuccessMessage("No se pudo cambiar la sucursal.", typeAlert.error, setSeeToast);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [responseOneQuote, id, quoteId, userId, callQuoteOne, setSeeToast]);
    var _168 = useInsurance(setTitleInsured, setIsUpdate, setOpenModal, setOpenModalAddInsurance, dataFormInsurance, setDataFormInsurance, dataFormInsuranceSp, setDataFormInsuranceSp, insuranceType, setRows, responseOneQuote, quoteId ? quoteId : id, clientId, personId, isUpdate, setIsMaskedDocument, setPersonId, listIdentificationType, insuredType, setIsInsurance, setDocument, setTrigger, showNewFormInsurance, setSeeToast), handleAddInsured = _168.handleAddInsured, setInsuranceStorybook = _168.setInsuranceStorybook, handleSubmitInsured = _168.handleSubmitInsured, editInsured = _168.editInsured, searchInsurancePerson = _168.searchInsurancePerson;
    var _169 = useBeneficiary(setIsUpdate, setInitialPercentage, setTitleBeneficiary, setOpenModalBeneficiary, dataFormBeneficiary, setDataFormBeneficiary, initialPercentage, responseOneQuote, clientId, isUpdate, setIsMaskedDocument, setPersonId, listIdentificationType), setBeneficiaryStorybook = _169.setBeneficiaryStorybook, handleAddBeneficiary = _169.handleAddBeneficiary, handleSubmitBeneficiary = _169.handleSubmitBeneficiary, getInsuredBeneficiary = _169.getInsuredBeneficiary, editBeneficiary = _169.editBeneficiary;
    var _170 = useActions(setOpenDrawerUpload, setPdfFile, setFileName, setIdDocumentClient, setModalDocumentClient, setUrlDocumentClient, setDocName, isVidaTermino, navigate, navigateNext, STEP, id, setOpenModalBackConfirm, isPlan, isDocumentClient, workFlowId, instanceId, currentStep, nextStep, currentStepId, nextStepId, pathLocation, navigation, sendProductCode, productCode), handleNext = _170.handleNext, handlePrevious = _170.handlePrevious, onClickBack = _170.onClickBack, handleCloseBackModal = _170.handleCloseBackModal, handleBackFromModal = _170.handleBackFromModal, handleClickContextMenu = _170.handleClickContextMenu, loadingComplete = _170.loadingComplete;
    var handleSendEmail = usePaymentConfirmation(policyId, dispatch, policyConfirm).handleSendEmail;
    var filterData = useFunctions().filterData;
    var _171 = useCertificateQuote(triggerCertificate, "cotizacion", quoteId, 1, 20), responseCertificateQuote = _171.responseCertificateQuote, errorCertificateQuote = _171.errorCertificateQuote, loadingCertificateQuote = _171.loadingCertificateQuote;
    var _172 = useCatalogues(propertyTypeId), loadingCatalogues = _172.loadingCatalogues, errorCatalogues = _172.errorCatalogues, businessType = _172.businessType, typeConstruction = _172.typeConstruction, businessShift = _172.businessShift;
    var _173 = PostUploadDocuments(uploadTrigger, id ? id : quoteId, fileName, pdfFile, idDocumentClient), responseUploadDocuments = _173.responseUploadDocuments, errorUploadDocuments = _173.errorUploadDocuments, loadingUploadDocuments = _173.loadingUploadDocuments;
    var _174 = GetCatalogBeneficiary(triggerCatalog, enable, page, limit, clientId), responseGetCatalogBeneficiary = _174.responseGetCatalogBeneficiary, errorGetCatalogBeneficiary = _174.errorGetCatalogBeneficiary, loadingGetCatalogBeneficiary = _174.loadingGetCatalogBeneficiary;
    var _175 = GetCatalogInsurance(triggerCatalogInsurance, enable, page, limit, clientId, planIdForCatalog), responseGetCatalogInsurance = _175.responseGetCatalogInsurance, errorGetCatalogInsurance = _175.errorGetCatalogInsurance, loadingGetCatalogInsurance = _175.loadingGetCatalogInsurance;
    var _176 = GetPersonByDocument(trigger, document), responsePersonByDocument = _176.responsePersonByDocument, errorPersonByDocument = _176.errorPersonByDocument, loadingPersonByDocument = _176.loadingPersonByDocument;
    var _177 = GetPaymentMode(triggerPaymentMode, projectId || idProject || ""), responsePaymentMode = _177.responsePaymentMode, errorPaymentMode = _177.errorPaymentMode, loadingPaymentMode = _177.loadingPaymentMode;
    var onSameDirection = function (checked, data) {
        var _a;
        if (data === "sameAddress") {
            if (checked === true) {
                var addressFromQuote_1 = ((_a = responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.address1) || "";
                setDataFormBusiness(function (prev) { return ({
                    Province: provinceId,
                    Town: townId,
                    Sector: sectorId,
                    propertyAddress: addressFromQuote_1,
                }); });
            }
            else {
                setDataFormBusiness(function (prev) { return ({
                    Province: "",
                    Town: "",
                    Sector: "",
                    propertyAddress: "",
                }); });
            }
        }
    };
    var _178 = useStartWokFlow(triggerStart, workFlow !== null && workFlow !== void 0 ? workFlow : "", function () { return setTriggerStart(false); }), loadingStartWorkFlow = _178.loadingStartWorkFlow, responseStartWorkFlow = _178.responseStartWorkFlow, errorStartWorkflow = _178.errorStartWorkflow;
    useErrorHandling({
        errorPersonByDocument: errorPersonByDocument,
        errorOneQuote: errorOneQuote,
        errorInsured: errorInsured,
        errorCatalogGender: errorCatalogGender,
        errorCountries: errorCountries,
        errorRegion: errorRegion,
        errorUpdateQuote: errorUpdateQuote,
        errorPlan: errorPlan,
        errorBeneficiary: errorBeneficiary,
        errorIdentificationType: errorIdentificationType,
        errorUpdatePerson: errorUpdatePerson,
        errorPatchBeneficiary: errorPatchBeneficiary,
        errorPatchInsured: errorPatchInsured,
        errorBenefit: errorBenefit,
        errorPostInsured: errorPostInsured,
        errorPlans: errorPlans,
        errorUploadDocuments: errorUploadDocuments,
        errorPaymentMode: errorPaymentMode,
        errorCertificateQuote: errorCertificateQuote,
        errorStartWorkflow: errorStartWorkflow,
        errorPolicyConfirm: responsePolicyConfirmError,
        setSeeToast: setSeeToast,
    });
    useEffect(function () {
        var _a;
        dispatch(pageActionFlagsClearData());
        // Remove summary from localStorage if coming from insurancePoliciesSummary
        if (idProject) {
            localStorage.removeItem("summary");
        }
        setProjectTrigger(true);
        if (idProject || projectId) {
            dispatch(projectOne({
                id: idProject ? idProject : projectId,
            }));
        }
        setTriggerCatalog(true);
        setTriggerPaymentMode(true);
        getActionFlags();
        if (!responseIdentificationType) {
            dispatch(identificationType({ enable: enable, page: page, limit: limit }));
        }
        if (!responseCountries) {
            dispatch(countries({ enable: enable, page: page, limit: limit }));
        }
        if (!(responseCatalogGender === null || responseCatalogGender === void 0 ? void 0 : responseCatalogGender.data)) {
            dispatch(catalogGender({ enable: enable, page: page, limit: limit }));
        }
        //Get Quote //
        var quoteIdLs = quoteIdLS;
        if (id !== undefined) {
            dispatch(quoteClearData());
            setCanEdit(isQuoteType);
            if (!isQuoteType) {
                setCanEditLocation(true);
                setCanEditContact(true);
            }
            //Get the quote by id
            callQuoteOne(id);
        }
        else {
            callQuoteOne(quoteIdLs);
        }
        callGetInsuredBeneficiary((_a = id !== null && id !== void 0 ? id : quoteIdLs) !== null && _a !== void 0 ? _a : "");
        // Note: callDispatchPlan moved to useEffect that waits for responseOneQuote
    }, []);
    useEffect(function () {
        if (!didMountRef.current) {
            didMountRef.current = true;
            return;
        }
        if (id !== undefined) {
            dispatch(quoteClearData());
            callQuoteOne(id);
        }
    }, [id]);
    // startFlow
    useEffect(function () {
        if (id !== undefined || isQuoteType) {
            setTriggerStart(true);
        }
    }, [workFlow]);
    useEffect(function () {
        var _a, _b;
        if (responseStartWorkFlow) {
            var nextStepId_1 = ((_a = responseStartWorkFlow.nextSteps[0]) === null || _a === void 0 ? void 0 : _a.nextSteps[0]) || "";
            setInstanceIdR(responseStartWorkFlow.instanceId);
            setCurrentStepId((_b = responseStartWorkFlow.currentStep) === null || _b === void 0 ? void 0 : _b.id);
            setNextStepId(nextStepId_1);
            localStorage.setItem("Quote", id !== null && id !== void 0 ? id : "");
            addStepInformationToAllSteps(workFlow !== null && workFlow !== void 0 ? workFlow : "", responseStartWorkFlow.instanceId);
            // Refrescar la información de los pasos después de actualizar localStorage
            setRefreshStepsInfo(function (prev) { return prev + 1; });
            dispatch(startWorkFlowClearData());
        }
    }, [responseStartWorkFlow]);
    //end startFlow
    useEffect(function () {
        var _a, _b, _c;
        if (responsePaymentMode && responsePaymentMode.length > 0) {
            // Transform payment mode response to select format
            var paymentModeList_1 = [];
            var quotePaymentModeId_1 = (_b = (_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.catalogPaymentMode) === null || _b === void 0 ? void 0 : _b.id;
            responsePaymentMode.map(function (item) {
                var _a, _b, _c, _d;
                var itemId = ((_a = item.catalogPaymentMode) === null || _a === void 0 ? void 0 : _a.id) || item.id;
                paymentModeList_1.push({
                    id: itemId,
                    name: ((_b = item.catalogPaymentMode) === null || _b === void 0 ? void 0 : _b.description) || item.description || "",
                    value: ((_c = item.catalogPaymentMode) === null || _c === void 0 ? void 0 : _c.code) ||
                        ((_d = item.catalogPaymentMode) === null || _d === void 0 ? void 0 : _d.id) ||
                        item.id,
                    default: quotePaymentModeId_1 ? itemId === quotePaymentModeId_1 : false,
                });
            });
            setPaymentMode(paymentModeList_1);
            // Set initial payment mode selection only if not already set and no quote data available
            if (!(paymentModelSelected === null || paymentModelSelected === void 0 ? void 0 : paymentModelSelected.id) &&
                paymentModeList_1.length > 0 &&
                !((_c = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _c === void 0 ? void 0 : _c.catalogPaymentMode)) {
                setPaymentModelSelected(paymentModeList_1[0]);
                // Set initial period when payment mode is first loaded
                setPeriod(paymentModeList_1[0].name);
            }
        }
    }, [responsePaymentMode, (_v = (_u = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _u === void 0 ? void 0 : _u.catalogPaymentMode) === null || _v === void 0 ? void 0 : _v.id]);
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        if (responseOneQuote && (responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data)) {
            setRowsPassengers((((_a = responseOneQuote.data.contentMap) === null || _a === void 0 ? void 0 : _a.additionalTravelers) || []).map(function (t) {
                var birthday = t.birthday || t.Birthday || "";
                var edad = "";
                if (birthday) {
                    var birth = new Date(birthday);
                    // Handle DD/MM/YYYY format
                    if (isNaN(birth.getTime())) {
                        var parts = birthday.split("/");
                        if (parts.length === 3) {
                            birth = new Date("".concat(parts[2], "-").concat(parts[1], "-").concat(parts[0]));
                        }
                    }
                    if (!isNaN(birth.getTime())) {
                        var today = new Date();
                        var age = today.getFullYear() - birth.getFullYear();
                        var m = today.getMonth() - birth.getMonth();
                        if (m < 0 || (m === 0 && today.getDate() < birth.getDate()))
                            age--;
                        edad = String(age);
                    }
                }
                return __assign(__assign({}, t), { birthday: birthday, edad: edad });
            }));
            var combustionMap = {
                GASOLINE: "Gasolina",
                DIESEL: "Diesel",
                ELECTRIC: "Eléctrico",
                GAS: "Gas",
            };
            var combustionType = (_b = responseOneQuote.data.contentMap) === null || _b === void 0 ? void 0 : _b.combustion;
            var carCombustion = combustionMap[combustionType] || "";
            var price = parsePrice(((_c = responseOneQuote.data.contentMap) === null || _c === void 0 ? void 0 : _c.deductibleTypeId) || 0);
            var newPrice = formatNumberCustom(price || 0);
            var car = {
                id: 1,
                brand: (_e = (_d = responseOneQuote.data.contentMap) === null || _d === void 0 ? void 0 : _d.brand) === null || _e === void 0 ? void 0 : _e.name,
                model: (_g = (_f = responseOneQuote.data.contentMap) === null || _f === void 0 ? void 0 : _f.model) === null || _g === void 0 ? void 0 : _g.name,
                fueltype: carCombustion,
                color: (_j = (_h = responseOneQuote.data.contentMap) === null || _h === void 0 ? void 0 : _h.colors) === null || _j === void 0 ? void 0 : _j.name,
                price: "RD$ ".concat(newPrice),
                cylinders: (_k = responseOneQuote.data.contentMap) === null || _k === void 0 ? void 0 : _k.cylinders,
                plate: (_l = responseOneQuote.data.contentMap) === null || _l === void 0 ? void 0 : _l.plate,
            };
            var vehicleDet = [];
            vehicleDet.push(car);
            setListVehicles(vehicleDet);
        }
    }, [responseOneQuote]);
    // Llenar datos de propiedad inmobiliaria
    useEffect(function () {
        var _a, _b, _c, _d;
        if (responseOneQuote && ((_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.contentMap)) {
            var contentMap_1 = responseOneQuote.data.contentMap;
            setPropertyTypeId(contentMap_1.propertyTypeId || "");
            setDamageBackup(formatToTwoDecimals(contentMap_1.damageBackup));
            setInsuredProperty(formatToTwoDecimals(contentMap_1.insuredProperty));
            setDataFormBusiness({
                ownerName: contentMap_1.ownerName,
                ownerIdNumber: contentMap_1.ownerIdNumber,
                propertyTypeId: contentMap_1.propertyTypeId,
                businessShift: contentMap_1.businessShift,
                sameAddress: contentMap_1.sameAddress,
                Province: contentMap_1.province,
                Town: contentMap_1.town,
                Sector: contentMap_1.sector,
                typeConstruction: contentMap_1.typeConstruction,
                propertyAddress: contentMap_1.propertyAddress,
                coverageNotes: contentMap_1.coverageNotes,
                typeProperty: contentMap_1.typeProperty,
                buildingValue: formatToTwoDecimals(contentMap_1.buildingValue),
                merchandiseValue: formatToTwoDecimals(contentMap_1.merchandiseValue),
                furnitureValue: formatToTwoDecimals(contentMap_1.furnitureValue),
                totalInsuredValue: formatToTwoDecimals(contentMap_1.transitValue),
            });
            if (contentMap_1.ownerName ||
                contentMap_1.businessShift ||
                contentMap_1.typeConstruction ||
                contentMap_1.propertyTypeId ||
                contentMap_1.address ||
                contentMap_1.constructionTypeName) {
                var businessTypeName = ((_b = businessType.find(function (item) { return item.id === contentMap_1.propertyTypeId; })) === null || _b === void 0 ? void 0 : _b.name) ||
                    contentMap_1.propertyTypeId ||
                    "";
                var businessShiftName = ((_c = businessShift.find(function (item) { return item.id === contentMap_1.businessShift; })) === null || _c === void 0 ? void 0 : _c.name) ||
                    contentMap_1.businessShift ||
                    "";
                var typeConstructionName = ((_d = typeConstruction.find(function (item) { return item.id === contentMap_1.typeConstruction; })) === null || _d === void 0 ? void 0 : _d.name) ||
                    contentMap_1.typeConstruction ||
                    "";
                var propertyData = {
                    id: 1,
                    ownerName: contentMap_1.ownerName || "",
                    propertyTypeId: businessTypeName,
                    businessShift: businessShiftName,
                    typeConstruction: typeConstructionName,
                    typeConstructionName: contentMap_1.constructionTypeName || "",
                    propertyAddress: contentMap_1.address || "",
                };
                setRowsProperties([propertyData]);
            }
        }
    }, [responseOneQuote, businessType, businessShift, typeConstruction]);
    useEffect(function () {
        var _a, _b, _c, _d;
        if (responseCertificateQuote && ((_a = responseCertificateQuote.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var urlC = (_b = responseCertificateQuote.data[0]) === null || _b === void 0 ? void 0 : _b.url;
            if (urlC) {
                setUrlDocument(urlC);
                setNameDocument((_c = responseCertificateQuote.data[0]) === null || _c === void 0 ? void 0 : _c.title);
                setopenModalPdfViewer(true);
            }
            setTriggerCertificate(false);
            dispatch(certificateQuoteClearData());
        }
        else if (responseCertificateQuote &&
            ((_d = responseCertificateQuote.data) === null || _d === void 0 ? void 0 : _d.length) === 0) {
            setTriggerCertificate(false);
            showToastSuccessMessage("No se encontro ningun documento adjunto.", typeAlert.warning, setSeeToast);
            dispatch(certificateQuoteClearData());
        }
    }, [responseCertificateQuote]);
    // determina con que servicio iniciar el formulario de negocio
    useEffect(function () {
        if (planName) {
            var isCommerceValue_1 = planName.toLowerCase().includes("comercio");
            setIsCommerce(isCommerceValue_1);
            setDataFormBusiness(function (prev) { return (__assign(__assign({}, prev), { propertyTypeId: isCommerceValue_1 ? "1" : "2" })); });
        }
    }, [planName]);
    useEffect(function () {
        // Solo setear el país una vez cuando listCountries se cargue por primera vez
        if (listCountries.length > 0 && !countryInitializedRef.current) {
            var countryId_1 = getLogin().countryId || "";
            if (countryId_1) {
                setDataFormInsuranceSp(function (prev) { return (__assign(__assign({}, prev), { country: countryId_1 })); });
                countryInitializedRef.current = true;
            }
        }
    }, [listCountries]);
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73, _74, _75, _76, _77, _78, _79, _80, _81, _82, _83, _84, _85, _86, _87, _88, _89, _90, _91, _92, _93, _94, _95, _96, _97, _98, _99, _100, _101, _102, _103, _104, _105, _106, _107, _108, _109, _110, _111, _112, _113, _114, _115, _116, _117, _118, _119, _120, _121, _122, _123, _124, _125, _126, _127, _128, _129, _130, _131, _132, _133, _134, _135, _136, _137, _138, _139, _140, _141, _142, _143, _144, _145, _146, _147, _148, _149, _150, _151, _152, _153, _154, _155, _156, _157, _158, _159, _160, _161, _162, _163, _164, _165, _166, _167, _168, _169, _170, _171, _172, _173, _174, _175, _176, _177, _178, _179, _180, _181, _182, _183, _184, _185, _186, _187, _188, _189, _190, _191, _192, _193, _194, _195, _196, _197, _198, _199, _200, _201, _202, _203, _204, _205, _206, _207, _208, _209, _210, _211, _212, _213, _214, _215, _216, _217, _218, _219, _220, _221, _222, _223, _224, _225, _226, _227, _228, _229, _230, _231, _232, _233, _234, _235, _236, _237, _238;
        if (responseOneQuote && (responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data)) {
            setProvinceId((_b = (_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.province) === null || _b === void 0 ? void 0 : _b.id);
            setTowId((_d = (_c = responseOneQuote.data) === null || _c === void 0 ? void 0 : _c.municipality) === null || _d === void 0 ? void 0 : _d.id);
            setSectorId((_f = (_e = responseOneQuote.data) === null || _e === void 0 ? void 0 : _e.district) === null || _f === void 0 ? void 0 : _f.id);
            setPlanCode(((_g = responseOneQuote.data) === null || _g === void 0 ? void 0 : _g.planId.code) || "");
            setProductCode(((_j = (_h = responseOneQuote.data) === null || _h === void 0 ? void 0 : _h.productId) === null || _j === void 0 ? void 0 : _j.code) || "");
            setPersonQuoteId((_k = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _k === void 0 ? void 0 : _k.personId);
            setQuoteId((_l = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _l === void 0 ? void 0 : _l.id);
            setPlanId((_o = (_m = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _m === void 0 ? void 0 : _m.planId) === null || _o === void 0 ? void 0 : _o.id);
            setCoverTypeId((_q = (_p = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _p === void 0 ? void 0 : _p.coverType) === null || _q === void 0 ? void 0 : _q.id);
            setTriggerCatalogInsurance(true);
            setCampaignId((_s = (_r = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _r === void 0 ? void 0 : _r.campaignId) === null || _s === void 0 ? void 0 : _s.id);
            setCatalogPaymentMode((_u = (_t = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _t === void 0 ? void 0 : _t.catalogPaymentMode) === null || _u === void 0 ? void 0 : _u.id);
            setEmail((_w = (responseOneQuote && ((_v = responseOneQuote.data) === null || _v === void 0 ? void 0 : _v.email))) !== null && _w !== void 0 ? _w : "");
            var currentStatusQuote = (_y = (_x = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _x === void 0 ? void 0 : _x.catalogStatusQuote) === null || _y === void 0 ? void 0 : _y.description;
            setPlan({
                id: (_0 = (_z = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _z === void 0 ? void 0 : _z.planId) === null || _0 === void 0 ? void 0 : _0.id,
                name: (_2 = (_1 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _1 === void 0 ? void 0 : _1.planId) === null || _2 === void 0 ? void 0 : _2.name,
            });
            var quoteStatus_1 = currentStatusQuote === null || currentStatusQuote === void 0 ? void 0 : currentStatusQuote.toLowerCase();
            // Logica para mostrar o no los ducumentos de descarga
            var shouldShowDownloads = (function () {
                var _a;
                //If quote status Deny List exist evaulate list first
                if (downloadsStatusDenyList.length > 0 &&
                    !downloadsStatusDenyList.includes(quoteStatus_1)) {
                    // Prevent duplicate loading:
                    // - If id exists → skip
                    // - If id doesn't exist but there is a deny list then setCertificates
                    if (!id) {
                        var certs = (_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.certificates;
                        //Get the certificates
                        if (certs.length > 0) {
                            certs = certs.map(function (c, id) {
                                return {
                                    id: c.id,
                                    name: c.title,
                                    url: c.url,
                                };
                            });
                        }
                        setCertificates(certs);
                    }
                    return true;
                }
                // en el flujo de venta nuca se muestra
                if (id === undefined || isQuoteType)
                    return false;
                if (downloadsStatusDenyList.length > 0 &&
                    !downloadsStatusDenyList.includes(quoteStatus_1)) {
                    return true;
                }
                // Emitida siempre se muestra
                if (quoteStatus_1 === "emitida")
                    return true;
                // Cotizada no se muestra
                if (quoteStatus_1 === "cotizada")
                    return false;
                // Cancelada solo es es acap no se muestra
                if (quoteStatus_1 === "cancelada")
                    return !isAcapCompany;
                return false;
            })();
            //Set show payment tab by quote status if actionflag exist
            setHideTabPaymentInfo(!(isQuote === "false"));
            if (isThereTabPaymentStatusAllowList) {
                if (showTabPaymentStatusAllowList.includes(quoteStatus_1)) {
                    setHideTabPaymentInfo(false);
                }
                else {
                    setHideTabPaymentInfo(true);
                }
            }
            setShowDownloads(shouldShowDownloads);
            setPolicyId((_4 = (_3 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _3 === void 0 ? void 0 : _3.policyId) === null || _4 === void 0 ? void 0 : _4.id);
            setPolicyStatus((_8 = (_7 = (_6 = (_5 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _5 === void 0 ? void 0 : _5.policyId) === null || _6 === void 0 ? void 0 : _6.policyStatus) === null || _7 === void 0 ? void 0 : _7.description) !== null && _8 !== void 0 ? _8 : "");
            var pmData = (_9 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _9 === void 0 ? void 0 : _9.customerAccount;
            if (pmData) {
                var accountType = (_11 = (_10 = pmData === null || pmData === void 0 ? void 0 : pmData.accountType) === null || _10 === void 0 ? void 0 : _10.description) !== null && _11 !== void 0 ? _11 : "";
                setPaymentMethodCardData([
                    { name: "Tipo de cuenta", type: "label", label: accountType },
                    {
                        name: "Número de tarjeta / cuenta",
                        type: "label",
                        label: (_12 = pmData.accountNumber) !== null && _12 !== void 0 ? _12 : "",
                        showChangeButton: true,
                    },
                ]);
            }
            // INSURED CARD INFO
            var currencySymbol = ((_14 = (_13 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _13 === void 0 ? void 0 : _13.lastPrice) === null || _14 === void 0 ? void 0 : _14.currencySymbol) || "";
            var amount = (_17 = (_16 = (_15 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _15 === void 0 ? void 0 : _15.additionalDataMap) === null || _16 === void 0 ? void 0 : _16.coverageAmount) !== null && _17 !== void 0 ? _17 : "0.00";
            setRowsCardInfo([
                {
                    accountNumber: (_20 = (_19 = (_18 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _18 === void 0 ? void 0 : _18.additionalDataMap) === null || _19 === void 0 ? void 0 : _19.numberCard) !== null && _20 !== void 0 ? _20 : "",
                    revolvingLimit: "".concat(currencySymbol, " ").concat(formatToTwoDecimals(amount)),
                },
            ]);
            // END INSURED CARD INFO
            // Update paymentModelSelected with the catalogPaymentMode from quote
            if ((_21 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _21 === void 0 ? void 0 : _21.catalogPaymentMode) {
                var selectedPaymentMode = {
                    id: responseOneQuote.data.catalogPaymentMode.id,
                    name: responseOneQuote.data.catalogPaymentMode.description,
                    value: responseOneQuote.data.catalogPaymentMode.code ||
                        responseOneQuote.data.catalogPaymentMode.id,
                    label: responseOneQuote.data.catalogPaymentMode.description,
                };
                setPaymentModelSelected(selectedPaymentMode);
                // Set period from quote data
                setPeriod(responseOneQuote.data.catalogPaymentMode.description);
                // Update paymentMode array to mark the correct option as default
                if (paymentMode.length > 0) {
                    var updatedPaymentMode = paymentMode.map(function (mode) { return (__assign(__assign({}, mode), { default: mode.id === responseOneQuote.data.catalogPaymentMode.id })); });
                    setPaymentMode(updatedPaymentMode);
                }
            }
            setCatalogStatusQuote((_23 = (_22 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _22 === void 0 ? void 0 : _22.catalogStatusQuote) === null || _23 === void 0 ? void 0 : _23.id);
            var statusDescription = (_26 = (_25 = (_24 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _24 === void 0 ? void 0 : _24.catalogStatusQuote) === null || _25 === void 0 ? void 0 : _25.description) === null || _26 === void 0 ? void 0 : _26.toLowerCase();
            setAddAppointmentAction(statusDescription !== "ganada");
            setBranchId((_27 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _27 === void 0 ? void 0 : _27.branch);
            setPlanName((_29 = (_28 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _28 === void 0 ? void 0 : _28.planId) === null || _29 === void 0 ? void 0 : _29.name);
            // getInsuredBeneficiary();
            var gender = listGenders.find(function (g) { var _a, _b; return g.id === ((_b = (_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.catalogGender) === null || _b === void 0 ? void 0 : _b.id); });
            var HideMarriedName = (gender === null || gender === void 0 ? void 0 : gender.name) === "Femenino" ? false : true;
            setHideMarriedName(HideMarriedName);
            /*date = formattedDate(date);*/
            //Province
            dispatch(region({
                enable: enable,
                page: page,
                limit: limit,
                level: level1,
                clientId: lsLogin.getUserLoginStored().clientId,
            }));
            //Municipality
            dispatch(region({
                enable: enable,
                page: page,
                limit: limit,
                level: level2,
                parentRegionId: (_31 = (_30 = responseOneQuote.data) === null || _30 === void 0 ? void 0 : _30.municipality) === null || _31 === void 0 ? void 0 : _31.parentRegionId,
                clientId: lsLogin.getUserLoginStored().clientId,
            }));
            //District
            dispatch(region({
                enable: enable,
                page: page,
                limit: limit,
                level: level3,
                parentRegionId: (_33 = (_32 = responseOneQuote.data) === null || _32 === void 0 ? void 0 : _32.district) === null || _33 === void 0 ? void 0 : _33.parentRegionId,
                clientId: lsLogin.getUserLoginStored().clientId,
            }));
            var status = (_35 = (_34 = responseOneQuote.data) === null || _34 === void 0 ? void 0 : _34.catalogStatusQuote) === null || _35 === void 0 ? void 0 : _35.description;
            if (status == "Cancelada") {
                status = "Fecha de cancelación";
            }
            else if (status == "Emitida") {
                status = "Fecha de emisión";
            }
            else if (status == "Expirada") {
                status = "Fecha de expiración";
            }
            else {
                status = "Fecha de cotización";
            }
            var date = ((_37 = (_36 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _36 === void 0 ? void 0 : _36.policyId) === null || _37 === void 0 ? void 0 : _37.effectiveFrom) ||
                ((_38 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _38 === void 0 ? void 0 : _38.creationDate);
            var nextYearDate = undefined;
            var originalDate = void 0;
            if (date) {
                var originalDate_1 = new Date(date);
                originalDate_1.setFullYear(originalDate_1.getFullYear() + 1);
                nextYearDate = formattedDate(originalDate_1.toISOString());
                nextYearDate = originalDate_1.toISOString();
            }
            setDataForm({
                DocumentNumber: formatDocument(responseOneQuote && ((_39 = responseOneQuote.data) === null || _39 === void 0 ? void 0 : _39.numberId)),
                IdType: ((_41 = (_40 = responseOneQuote.data) === null || _40 === void 0 ? void 0 : _40.identificationTypeId) === null || _41 === void 0 ? void 0 : _41.id)
                    ? (_43 = (_42 = responseOneQuote.data) === null || _42 === void 0 ? void 0 : _42.identificationTypeId) === null || _43 === void 0 ? void 0 : _43.id
                    : "",
                Type: responseOneQuote &&
                    ((_45 = (_44 = responseOneQuote.data) === null || _44 === void 0 ? void 0 : _44.identificationTypeId) === null || _45 === void 0 ? void 0 : _45.description),
                QuoteNumber: responseOneQuote && ((_46 = responseOneQuote.data) === null || _46 === void 0 ? void 0 : _46.code),
                policeNumber: ((_47 = responseOneQuote.data) === null || _47 === void 0 ? void 0 : _47.policyId)
                    ? (_48 = responseOneQuote.data) === null || _48 === void 0 ? void 0 : _48.policyId.code
                    : "",
                Name: responseOneQuote && ((_49 = responseOneQuote.data) === null || _49 === void 0 ? void 0 : _49.firstNameA),
                SecondName: responseOneQuote && ((_50 = responseOneQuote.data) === null || _50 === void 0 ? void 0 : _50.firstNameB),
                FirstLastName: responseOneQuote && ((_51 = responseOneQuote.data) === null || _51 === void 0 ? void 0 : _51.lastNameA),
                SecondLastName: responseOneQuote && ((_52 = responseOneQuote.data) === null || _52 === void 0 ? void 0 : _52.lastNameB),
                MarriedSurName: responseOneQuote && ((_53 = responseOneQuote.data) === null || _53 === void 0 ? void 0 : _53.marriedName),
                Birthday: responseOneQuote && ((_54 = responseOneQuote.data) === null || _54 === void 0 ? void 0 : _54.dob),
                Address1: responseOneQuote && ((_55 = responseOneQuote.data) === null || _55 === void 0 ? void 0 : _55.address1),
                Address2: responseOneQuote && ((_56 = responseOneQuote.data) === null || _56 === void 0 ? void 0 : _56.address2),
                PhoneOffice: responseOneQuote && formatPhoneNumber((_57 = responseOneQuote.data) === null || _57 === void 0 ? void 0 : _57.phone2),
                PhoneHome: responseOneQuote && formatPhoneNumber((_58 = responseOneQuote.data) === null || _58 === void 0 ? void 0 : _58.phone1),
                PhoneNumber: responseOneQuote && formatPhoneNumber((_59 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _59 === void 0 ? void 0 : _59.phone3),
                Email: responseOneQuote && ((_60 = responseOneQuote.data) === null || _60 === void 0 ? void 0 : _60.email),
                QuoteStatusName: responseOneQuote &&
                    ((_62 = (_61 = responseOneQuote.data) === null || _61 === void 0 ? void 0 : _61.catalogStatusQuote) === null || _62 === void 0 ? void 0 : _62.description),
                QuoteDate: isApapAuto
                    ? ((_63 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _63 === void 0 ? void 0 : _63.policyId)
                        ? formattedDate(date)
                        : formattedDateTime(date)
                    : formattedDate(date),
                effectiveDate: responseOneQuote && ((_64 = responseOneQuote.data) === null || _64 === void 0 ? void 0 : _64.policyId)
                    ? nextYearDate
                    : "",
                PlanTypeName: responseOneQuote && ((_66 = (_65 = responseOneQuote.data) === null || _65 === void 0 ? void 0 : _65.planId) === null || _66 === void 0 ? void 0 : _66.name),
                CampaignName: responseOneQuote && ((_68 = (_67 = responseOneQuote.data) === null || _67 === void 0 ? void 0 : _67.campaignId) === null || _68 === void 0 ? void 0 : _68.name),
                IdTypeName: responseOneQuote &&
                    ((_70 = (_69 = responseOneQuote.data) === null || _69 === void 0 ? void 0 : _69.identificationTypeId) === null || _70 === void 0 ? void 0 : _70.description),
                Gender: responseOneQuote && ((_72 = (_71 = responseOneQuote.data) === null || _71 === void 0 ? void 0 : _71.catalogGender) === null || _72 === void 0 ? void 0 : _72.id),
                Country: responseOneQuote && ((_74 = (_73 = responseOneQuote.data) === null || _73 === void 0 ? void 0 : _73.nationality) === null || _74 === void 0 ? void 0 : _74.id),
                CountryName: responseOneQuote && ((_76 = (_75 = responseOneQuote.data) === null || _75 === void 0 ? void 0 : _75.nationality) === null || _76 === void 0 ? void 0 : _76.name),
                Province: responseOneQuote && ((_78 = (_77 = responseOneQuote.data) === null || _77 === void 0 ? void 0 : _77.province) === null || _78 === void 0 ? void 0 : _78.id),
                ProvinceName: responseOneQuote && ((_80 = (_79 = responseOneQuote.data) === null || _79 === void 0 ? void 0 : _79.province) === null || _80 === void 0 ? void 0 : _80.name),
                TownName: responseOneQuote && ((_82 = (_81 = responseOneQuote.data) === null || _81 === void 0 ? void 0 : _81.municipality) === null || _82 === void 0 ? void 0 : _82.name),
                Town: responseOneQuote && ((_84 = (_83 = responseOneQuote.data) === null || _83 === void 0 ? void 0 : _83.municipality) === null || _84 === void 0 ? void 0 : _84.id),
                Sector: responseOneQuote && ((_86 = (_85 = responseOneQuote.data) === null || _85 === void 0 ? void 0 : _85.district) === null || _86 === void 0 ? void 0 : _86.id),
                SectorName: responseOneQuote && ((_88 = (_87 = responseOneQuote.data) === null || _87 === void 0 ? void 0 : _87.district) === null || _88 === void 0 ? void 0 : _88.name),
                PostalCode: responseOneQuote && ((_89 = responseOneQuote.data) === null || _89 === void 0 ? void 0 : _89.zip),
            });
            //setFormVehicle
            setIdQuoteVehicle((_91 = (_90 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _90 === void 0 ? void 0 : _90.contentMap) === null || _91 === void 0 ? void 0 : _91.idquoteVehicle);
            setProductId((_93 = (_92 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _92 === void 0 ? void 0 : _92.productId) === null || _93 === void 0 ? void 0 : _93.id);
            var carConditionName = void 0;
            switch ((_95 = (_94 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _94 === void 0 ? void 0 : _94.contentMap) === null || _95 === void 0 ? void 0 : _95.condition) {
                case "USED":
                    carConditionName = "Usado";
                    break;
                case "NEW":
                    carConditionName = "Nuevo";
                    break;
            }
            if ((_96 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _96 === void 0 ? void 0 : _96.profileDocuments) {
                var isCancelledQuote_1 = ((_99 = (_98 = (_97 = responseOneQuote.data) === null || _97 === void 0 ? void 0 : _97.catalogStatusQuote) === null || _98 === void 0 ? void 0 : _98.description) === null || _99 === void 0 ? void 0 : _99.toLowerCase()) ===
                    "cancelada";
                var pendingCount = responseOneQuote.data.profileDocuments.filter(function (doc) { return (doc === null || doc === void 0 ? void 0 : doc.status) === "PENDING" && (doc === null || doc === void 0 ? void 0 : doc.required) === true; }).length;
                setCountBadge(pendingCount);
                var dataRows = (_101 = (_100 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _100 === void 0 ? void 0 : _100.profileDocuments) === null || _101 === void 0 ? void 0 : _101.slice().sort(function (a, b) { return (b.required ? 1 : 0) - (a.required ? 1 : 0); }).filter(function (item) {
                    var _a;
                    if (!isCancelledQuote_1) {
                        return !((_a = item.name) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes("cancelaci"));
                    }
                    return true;
                }).map(function (item) {
                    var _a;
                    return ({
                        id: item.id,
                        docType: item.name,
                        mandatory: item.required === true ? "Requerido" : "Opcional",
                        state: (function () {
                            switch (item.status) {
                                case "PENDING":
                                    return "Pendiente";
                                case "READY":
                                    return "Listo";
                            }
                        })(),
                        required: item.required,
                        date: "",
                        user: "",
                        documentClientUrl: ((_a = item.document) === null || _a === void 0 ? void 0 : _a.path) || "",
                    });
                });
                setProfileDocumentsRows(dataRows);
            }
            var fuelTypeName = void 0;
            switch ((_103 = (_102 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _102 === void 0 ? void 0 : _102.contentMap) === null || _103 === void 0 ? void 0 : _103.combustion) {
                case "GAS":
                    fuelTypeName = "Gas";
                    break;
                case "ELECTRIC":
                    fuelTypeName = "Eléctrico";
                    break;
                case "DIESEL":
                    fuelTypeName = "Diesel";
                    break;
                case "GASOLINE":
                    fuelTypeName = "Gasolina";
                    break;
            }
            var countChassis = ((_105 = (_104 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _104 === void 0 ? void 0 : _104.contentMap) === null || _105 === void 0 ? void 0 : _105.chassisNumber) || "";
            var isChassisValid = (countChassis === null || countChassis === void 0 ? void 0 : countChassis.length) !== 17;
            setDataFormVehicle({
                carDetails: [
                    {
                        brand: {
                            id: (_108 = (_107 = (_106 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _106 === void 0 ? void 0 : _106.contentMap) === null || _107 === void 0 ? void 0 : _107.brand) === null || _108 === void 0 ? void 0 : _108.id,
                            name: (_111 = (_110 = (_109 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _109 === void 0 ? void 0 : _109.contentMap) === null || _110 === void 0 ? void 0 : _110.brand) === null || _111 === void 0 ? void 0 : _111.name,
                        },
                        model: {
                            id: (_114 = (_113 = (_112 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _112 === void 0 ? void 0 : _112.contentMap) === null || _113 === void 0 ? void 0 : _113.model) === null || _114 === void 0 ? void 0 : _114.id,
                            name: (_117 = (_116 = (_115 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _115 === void 0 ? void 0 : _115.contentMap) === null || _116 === void 0 ? void 0 : _116.model) === null || _117 === void 0 ? void 0 : _117.name,
                        },
                        version: {
                            id: (_120 = (_119 = (_118 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _118 === void 0 ? void 0 : _118.contentMap) === null || _119 === void 0 ? void 0 : _119.version) === null || _120 === void 0 ? void 0 : _120.id,
                            name: (_123 = (_122 = (_121 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _121 === void 0 ? void 0 : _121.contentMap) === null || _122 === void 0 ? void 0 : _122.version) === null || _123 === void 0 ? void 0 : _123.name,
                        },
                        class: {
                            id: (_126 = (_125 = (_124 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _124 === void 0 ? void 0 : _124.contentMap) === null || _125 === void 0 ? void 0 : _125.class) === null || _126 === void 0 ? void 0 : _126.id,
                            name: (_129 = (_128 = (_127 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _127 === void 0 ? void 0 : _127.contentMap) === null || _128 === void 0 ? void 0 : _128.class) === null || _129 === void 0 ? void 0 : _129.name,
                        },
                        type: {
                            id: (_132 = (_131 = (_130 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _130 === void 0 ? void 0 : _130.contentMap) === null || _131 === void 0 ? void 0 : _131.type) === null || _132 === void 0 ? void 0 : _132.id,
                            name: (_135 = (_134 = (_133 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _133 === void 0 ? void 0 : _133.contentMap) === null || _134 === void 0 ? void 0 : _134.type) === null || _135 === void 0 ? void 0 : _135.name,
                        },
                        weight: (_137 = (_136 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _136 === void 0 ? void 0 : _136.contentMap) === null || _137 === void 0 ? void 0 : _137.weight,
                        tonnage: (_139 = (_138 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _138 === void 0 ? void 0 : _138.contentMap) === null || _139 === void 0 ? void 0 : _139.tonnage,
                        passengerCant: (_141 = (_140 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _140 === void 0 ? void 0 : _140.contentMap) === null || _141 === void 0 ? void 0 : _141.passengerCant,
                    },
                ],
                year: (_143 = (_142 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _142 === void 0 ? void 0 : _142.contentMap) === null || _143 === void 0 ? void 0 : _143.year,
                carColor: [
                    {
                        id: (_146 = (_145 = (_144 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _144 === void 0 ? void 0 : _144.contentMap) === null || _145 === void 0 ? void 0 : _145.colors) === null || _146 === void 0 ? void 0 : _146.id,
                        name: (_149 = (_148 = (_147 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _147 === void 0 ? void 0 : _147.contentMap) === null || _148 === void 0 ? void 0 : _148.colors) === null || _149 === void 0 ? void 0 : _149.name,
                    },
                ],
                chassisNumber: (_151 = (_150 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _150 === void 0 ? void 0 : _150.contentMap) === null || _151 === void 0 ? void 0 : _151.chassisNumber,
                shortChassis: isChassisValid,
                price: (_153 = (_152 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _152 === void 0 ? void 0 : _152.contentMap) === null || _153 === void 0 ? void 0 : _153.deductibleTypeId,
                numberCylinders: [
                    {
                        id: (_155 = (_154 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _154 === void 0 ? void 0 : _154.contentMap) === null || _155 === void 0 ? void 0 : _155.cylinders,
                        name: (_157 = (_156 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _156 === void 0 ? void 0 : _156.contentMap) === null || _157 === void 0 ? void 0 : _157.cylinders,
                    },
                ],
                fuelType: [
                    {
                        id: (_159 = (_158 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _158 === void 0 ? void 0 : _158.contentMap) === null || _159 === void 0 ? void 0 : _159.combustion,
                        name: fuelTypeName,
                    },
                ],
                registrationNumber: (_161 = (_160 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _160 === void 0 ? void 0 : _160.contentMap) === null || _161 === void 0 ? void 0 : _161.plate,
                carCondition: [
                    {
                        id: (_163 = (_162 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _162 === void 0 ? void 0 : _162.contentMap) === null || _163 === void 0 ? void 0 : _163.condition,
                        name: carConditionName,
                    },
                ],
            });
            //EndFormVehicle
            //setStatementRows
            if (responseOneQuote.data.billing) {
                var dataRows = (_165 = (_164 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _164 === void 0 ? void 0 : _164.billing) === null || _165 === void 0 ? void 0 : _165.map(function (item) { return ({
                    accountName: item.account,
                    amount: "RD$ ".concat(item.amount),
                    paymentDate: newFormattedDate(item.paymentDate),
                    dateExpire: newFormattedDate(item.dateExpire),
                    datePaid: newFormattedDate(item.datePaid),
                    state: (function () {
                        switch (item.statusBilling) {
                            case "GENERATED":
                                return "Generado";
                            case "EMMITED":
                                return "Emitido";
                            case "PAID":
                                return "Pagado";
                            case "CANCELLED":
                                return "Cancelado";
                        }
                    })(),
                }); });
                setStatementRows(dataRows);
            }
            // EndSetStatmentRows
            // if (id) {
            // setPrime(responseOneQuote?.data?.lastPrice?.amount);
            setPrime(((_167 = (_166 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _166 === void 0 ? void 0 : _166.lastPrice) === null || _167 === void 0 ? void 0 : _167.currencySymbol) &&
                ((_169 = (_168 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _168 === void 0 ? void 0 : _168.lastPrice) === null || _169 === void 0 ? void 0 : _169.amount)
                ? "".concat(afy_currency !== null && afy_currency !== void 0 ? afy_currency : (_171 = (_170 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _170 === void 0 ? void 0 : _170.lastPrice) === null || _171 === void 0 ? void 0 : _171.currencySymbol, " ").concat(formatToTwoDecimals((_173 = (_172 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _172 === void 0 ? void 0 : _172.lastPrice) === null || _173 === void 0 ? void 0 : _173.amount))
                : "0.00");
            callDispatchPageActionFlags((_175 = (_174 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _174 === void 0 ? void 0 : _174.planId) === null || _175 === void 0 ? void 0 : _175.projectId);
            // Update projectId from the quote response
            if ((_177 = (_176 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _176 === void 0 ? void 0 : _176.planId) === null || _177 === void 0 ? void 0 : _177.projectId) {
                setProjectId(responseOneQuote.data.planId.projectId);
            }
            var campaignData = {
                id: (_179 = (_178 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _178 === void 0 ? void 0 : _178.campaignId) === null || _179 === void 0 ? void 0 : _179.id,
                name: (_181 = (_180 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _180 === void 0 ? void 0 : _180.campaignId) === null || _181 === void 0 ? void 0 : _181.name,
                value: (_183 = (_182 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _182 === void 0 ? void 0 : _182.campaignId) === null || _183 === void 0 ? void 0 : _183.id,
            };
            setCampaignSelected(campaignData);
            if (id) {
                if (isQuote === "false") {
                    setBreadCrumbs([]);
                }
                else {
                    setBreadCrumbs(stepProgress(STEP, true));
                }
                var certs = (_184 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _184 === void 0 ? void 0 : _184.certificates;
                //Get the certificates
                if (certs.length > 0) {
                    certs = certs.map(function (c, id) {
                        return {
                            id: c.id,
                            name: c.title,
                            url: c.url,
                            status: c.status,
                        };
                    });
                }
                setCertificates(certs);
                //Get the additional payment info
                if ((responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) && isQuote && isQuote === "false") {
                    var additionalInfo = [];
                    var data = responseOneQuote.data;
                    var lastPrice = data.lastPrice, customerAccount = data.customerAccount, catalogPaymentMode_1 = data.catalogPaymentMode, id_1 = data.id;
                    var amount_1 = (_185 = lastPrice === null || lastPrice === void 0 ? void 0 : lastPrice.amount) !== null && _185 !== void 0 ? _185 : "0.00";
                    var currencySymbol_1 = (lastPrice === null || lastPrice === void 0 ? void 0 : lastPrice.currencySymbol) || "";
                    var formattedAmount = formatToTwoDecimals(amount_1);
                    additionalInfo.push({
                        id: id_1,
                        accountName: customerAccount === null || customerAccount === void 0 ? void 0 : customerAccount.accountName,
                        accountNumber: customerAccount === null || customerAccount === void 0 ? void 0 : customerAccount.accountNumber,
                        accountType: (_186 = customerAccount === null || customerAccount === void 0 ? void 0 : customerAccount.accountType) === null || _186 === void 0 ? void 0 : _186.description,
                        paymentMode: catalogPaymentMode_1 === null || catalogPaymentMode_1 === void 0 ? void 0 : catalogPaymentMode_1.description,
                        prime: "".concat(currencySymbol_1, " ").concat(formattedAmount),
                        lastDigits: "N/A",
                    });
                    setRows2(additionalInfo);
                }
            }
            else {
                setRows2([
                    {
                        id: "1",
                        accountName: "N/A",
                        accountNumber: "N/A",
                        accountType: "N/A",
                        paymentMode: "N/A",
                        prime: "N/A",
                        lastDigits: "N/A",
                    },
                ]);
            }
            /*Adiciona al resumen la informacion de vehiculos*/
            switch ((_188 = (_187 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _187 === void 0 ? void 0 : _187.contentMap) === null || _188 === void 0 ? void 0 : _188.condition) {
                case "USED":
                    carConditionName = "Usado";
                    break;
                case "NEW":
                    carConditionName = "Nuevo";
                    break;
            }
            var price = ((_190 = (_189 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _189 === void 0 ? void 0 : _189.lastPrice) === null || _190 === void 0 ? void 0 : _190.currencySymbol) &&
                ((_192 = (_191 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _191 === void 0 ? void 0 : _191.lastPrice) === null || _192 === void 0 ? void 0 : _192.amount)
                ? "".concat(afy_currency !== null && afy_currency !== void 0 ? afy_currency : (_194 = (_193 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _193 === void 0 ? void 0 : _193.lastPrice) === null || _194 === void 0 ? void 0 : _194.currencySymbol, " ").concat(formatToTwoDecimals((_196 = (_195 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _195 === void 0 ? void 0 : _195.lastPrice) === null || _196 === void 0 ? void 0 : _196.amount))
                : "RD$ 0.00";
            var baseFilters = [
                {
                    name: "Producto",
                    type: "label",
                    label: (_199 = (_198 = (_197 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _197 === void 0 ? void 0 : _197.productId) === null || _198 === void 0 ? void 0 : _198.description) !== null && _199 !== void 0 ? _199 : "",
                },
                {
                    name: "Plan",
                    type: "label",
                    label: (_202 = (_201 = (_200 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _200 === void 0 ? void 0 : _200.planId) === null || _201 === void 0 ? void 0 : _201.name) !== null && _202 !== void 0 ? _202 : "",
                    showChangeButton: !hideChangeButton,
                },
                {
                    name: "Modalidad de Pago",
                    type: "label",
                    label: (function () {
                        var _a, _b, _c, _d, _e;
                        var desc = (_b = (_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.catalogPaymentMode) === null || _b === void 0 ? void 0 : _b.description;
                        if (desc)
                            return desc;
                        var freq = (_d = (_c = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _c === void 0 ? void 0 : _c.additionalDataMap) === null || _d === void 0 ? void 0 : _d.paymentFrequency;
                        if (!freq)
                            return "";
                        var freqMap = {
                            ANNUAL: "Anual",
                            MONTHLY: "Mensual",
                            QUARTERLY: "Trimestral",
                            SEMIANNUAL: "Semestral",
                        };
                        return (_e = freqMap[freq]) !== null && _e !== void 0 ? _e : freq;
                    })(),
                    showChangeButton: !hideChangeButton,
                },
                {
                    name: "Tipo de Cobertura",
                    type: "label",
                    label: (_208 = (_205 = (_204 = (_203 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _203 === void 0 ? void 0 : _203.coverType) === null || _204 === void 0 ? void 0 : _204.description) !== null && _205 !== void 0 ? _205 : (_207 = (_206 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _206 === void 0 ? void 0 : _206.coverType) === null || _207 === void 0 ? void 0 : _207.name) !== null && _208 !== void 0 ? _208 : "",
                    showChangeButton: !hideChangeButton,
                },
                {
                    name: "Campaña",
                    type: "label",
                    label: (_211 = (_210 = (_209 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _209 === void 0 ? void 0 : _209.campaignId) === null || _210 === void 0 ? void 0 : _210.name) !== null && _211 !== void 0 ? _211 : "",
                },
            ];
            var labelPrice = ((_213 = (_212 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _212 === void 0 ? void 0 : _212.catalogStatusQuote) === null || _213 === void 0 ? void 0 : _213.code) !== "G"
                ? (afy_label_premium !== null && afy_label_premium !== void 0 ? afy_label_premium : "Prima")
                : "Prima";
            var filtersPlan = [
                {
                    name: labelPrice,
                    type: "label",
                    label: price,
                },
            ];
            setDefaultFilters(isQuote === "false" ||
                (afy_premium_always_visible && afy_premium_always_visible === "true")
                ? __spreadArray(__spreadArray([], baseFilters, true), filtersPlan, true) : baseFilters);
            setReferrerRows([
                {
                    id: 1,
                    names: (_216 = (_215 = (_214 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _214 === void 0 ? void 0 : _214.user) === null || _215 === void 0 ? void 0 : _215.fullName) !== null && _216 !== void 0 ? _216 : "",
                    employeeCode: (_219 = (_218 = (_217 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _217 === void 0 ? void 0 : _217.user) === null || _218 === void 0 ? void 0 : _218.employeeCode) !== null && _219 !== void 0 ? _219 : "",
                    employeePosition: (_222 = (_221 = (_220 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _220 === void 0 ? void 0 : _220.user) === null || _221 === void 0 ? void 0 : _221.employeePosition) !== null && _222 !== void 0 ? _222 : "",
                    branch: (_225 = (_224 = (_223 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _223 === void 0 ? void 0 : _223.branchData) === null || _224 === void 0 ? void 0 : _224.name) !== null && _225 !== void 0 ? _225 : "",
                    quoteDate: ((_226 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _226 === void 0 ? void 0 : _226.creationDate)
                        ? formattedDate(responseOneQuote.data.creationDate)
                        : "",
                    policyDate: ((_228 = (_227 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _227 === void 0 ? void 0 : _227.policyId) === null || _228 === void 0 ? void 0 : _228.effectiveFrom)
                        ? formattedDate(responseOneQuote.data.policyId.effectiveFrom)
                        : "",
                },
            ]);
            var selectedPm = {
                id: (_230 = (_229 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _229 === void 0 ? void 0 : _229.catalogPaymentMode) === null || _230 === void 0 ? void 0 : _230.id,
                name: ((_232 = (_231 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _231 === void 0 ? void 0 : _231.catalogPaymentMode) === null || _232 === void 0 ? void 0 : _232.description) ||
                    "From Quote Response",
                value: ((_234 = (_233 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _233 === void 0 ? void 0 : _233.catalogPaymentMode) === null || _234 === void 0 ? void 0 : _234.code) ||
                    ((_236 = (_235 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _235 === void 0 ? void 0 : _235.catalogPaymentMode) === null || _236 === void 0 ? void 0 : _236.id),
            };
            callDispatchPlan(selectedPm, undefined, (_238 = (_237 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _237 === void 0 ? void 0 : _237.planId) === null || _238 === void 0 ? void 0 : _238.projectId);
        }
        dispatch(projectOneClearData());
    }, [
        responseOneQuote,
        downloadsStatusDenyList,
        isThereTabPaymentStatusAllowList,
    ]);
    useEffect(function () {
        if (responseOneProject) {
            if (id) {
                setLocalStorage(responseOneProject);
            }
        }
    }, [responseOneProject]);
    useEffect(function () {
        var _a, _b;
        if (responseGetCatalogBeneficiary && (responseGetCatalogBeneficiary === null || responseGetCatalogBeneficiary === void 0 ? void 0 : responseGetCatalogBeneficiary.data)) {
            var beneficiaryList_1 = [];
            (_a = responseGetCatalogBeneficiary.data) === null || _a === void 0 ? void 0 : _a.map(function (item) {
                beneficiaryList_1.push({
                    id: item.id,
                    name: item.description ? item.description : "",
                    value: item.id,
                });
            });
            setBeneficiaryType(beneficiaryList_1);
            setDataFormBeneficiary(__assign(__assign({}, dataFormBeneficiary), { idTypeInsured: (_b = beneficiaryList_1[0].value) !== null && _b !== void 0 ? _b : "" }));
        }
    }, [responseGetCatalogBeneficiary]);
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f;
        if (responseGetCatalogInsurance && (responseGetCatalogInsurance === null || responseGetCatalogInsurance === void 0 ? void 0 : responseGetCatalogInsurance.data)) {
            var insuranceList_1 = [];
            (_a = responseGetCatalogInsurance.data) === null || _a === void 0 ? void 0 : _a.map(function (item) {
                var _a;
                insuranceList_1.push({
                    id: item.id,
                    name: item.description ? item.description : "",
                    value: item.id,
                    code: (_a = item.code) !== null && _a !== void 0 ? _a : "",
                });
            });
            setInsuredType(insuranceList_1);
            setDataFormInsurance(__assign(__assign({}, dataFormInsurance), { idInsuredType: (_b = insuranceList_1[0].value) !== null && _b !== void 0 ? _b : "" }));
            // Buscar el elemento que contenga "Titular" o "titular"
            var titularItem = insuranceList_1.find(function (item) {
                return item.name.toLowerCase().includes("titular");
            });
            setInsuranceType((_d = (_c = titularItem === null || titularItem === void 0 ? void 0 : titularItem.value) !== null && _c !== void 0 ? _c : insuranceList_1[0].value) !== null && _d !== void 0 ? _d : "");
            setDataFormInsuranceSp(__assign(__assign({}, dataFormInsuranceSp), { idInsuredType: (_f = (_e = titularItem === null || titularItem === void 0 ? void 0 : titularItem.value) !== null && _e !== void 0 ? _e : insuranceList_1[0].value) !== null && _f !== void 0 ? _f : "" }));
        }
    }, [responseGetCatalogInsurance]);
    useEffect(function () {
        var _a, _b, _c;
        if (responsePlans) {
            var dataST_1 = [];
            // Prioritize payment mode from quote data
            var paymentModeFromQuote = (_b = (_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.catalogPaymentMode) === null || _b === void 0 ? void 0 : _b.description;
            var pm = (_c = localStorageService.getStepStored().steps[Steps.plan]
                .paymentModeSelected) === null || _c === void 0 ? void 0 : _c.name;
            // User selection takes priority; fall back to quote data, then localStorage
            var paymentPeriod_1 = period || paymentModeFromQuote || pm;
            if (period === undefined && paymentPeriod_1) {
                setPeriod(paymentPeriod_1);
            }
            responsePlans
                .filter(function (item) { var _a, _b; return item.price && Number((_b = (_a = item.price) === null || _a === void 0 ? void 0 : _a.amount) === null || _b === void 0 ? void 0 : _b.replace(/,/g, "")) > 0; })
                .map(function (item) {
                var _a;
                dataST_1.push({
                    id: item.id,
                    name: item.name ? item.name.replace(/"/g, "") : "",
                    logo: item.sponsorLogoUrl && item.sponsorLogoUrl,
                    backgroundColor: "#ffffff",
                    currency: "$",
                    itemsValue: [],
                    option: setCoverTypeStorybook(item.coverTypes ? item.coverTypes : [], (coverTypeSelected === null || coverTypeSelected === void 0 ? void 0 : coverTypeSelected.id) || (coverTypeSelected === null || coverTypeSelected === void 0 ? void 0 : coverTypeSelected.value)),
                    period: paymentPeriod_1,
                    price: (_a = item.price) === null || _a === void 0 ? void 0 : _a.amount,
                    textColor: "#3A56A1",
                    paymentMethod: paymentModelSelected,
                });
            });
            setPlanData(__assign(__assign({}, plan), { data: dataST_1 }));
        }
    }, [
        responsePlans,
        responseOneQuote,
        paymentModelSelected,
        coverTypeSelected,
    ]);
    useEffect(function () {
        if (listIdentificationType.length > 0 &&
            listGenders.length > 0 &&
            listCountries.length > 0 &&
            listRegionLevel1.length > 0 &&
            listRegionLevel2.length > 0 &&
            listRegionLevel3.length > 0 &&
            !showComponent) {
            setShowComponent(true);
        }
    }, [
        listIdentificationType,
        listGenders,
        listCountries,
        listRegionLevel1,
        listRegionLevel2,
        listRegionLevel3,
    ]);
    // Sólo persiste la respuesta de la API y actualiza el estado de flags.
    // El procesamiento real ocurre en el effect de actionFlags de abajo.
    useEffect(function () {
        if (responsePageActionFlags) {
            lsPageActionFlags.setPageActionFlagsStored(responsePageActionFlags);
            setActionFlags(responsePageActionFlags);
            dispatch(pageActionFlagsClearData());
        }
    }, [responsePageActionFlags]);
    // Procesa los flags cada vez que cambian (API o localStorage al montar).
    // Esto garantiza que getActionFlags() siempre recibe los flags actuales.
    useEffect(function () {
        if (!actionFlags || actionFlags.length === 0)
            return;
        getActionFlags();
        // defaults antes del forEach
        setIsThereShowTabPaymentStatusAllowList(false);
        setShowTabPaymentStatusAllowList([]);
        setHideTabDocumentClient(isApapAuto && (isQuote === "true" || isQuote === undefined));
        actionFlags.forEach(function (actionFlag) {
            if (actionFlag.name === "afy-show-plan-travel-range-info") {
                setIsTravelInsurance(true);
            }
            if (actionFlag.name === "afy-confirm-data-downloads-status-denylist") {
                var statusdenylist_1 = JSON.parse(actionFlag.value);
                setDownloadsStatusDenyList(function (prev) {
                    if (JSON.stringify(prev) === JSON.stringify(statusdenylist_1))
                        return prev;
                    return statusdenylist_1;
                });
            }
            if (actionFlag.name === "afy-confirm-data-show-tab-payment-status-allowlist") {
                setIsThereShowTabPaymentStatusAllowList(true);
                var statusallowlist_1 = JSON.parse(actionFlag.value);
                setShowTabPaymentStatusAllowList(function (prev) {
                    if (JSON.stringify(prev) === JSON.stringify(statusallowlist_1))
                        return prev;
                    return statusallowlist_1;
                });
            }
            if (actionFlag.name === "afy-confirm-data-show-tab-client-documents") {
                setHideTabDocumentClient(actionFlag.value !== "true");
            }
            if (actionFlag.name === "afy-conf-holidays-rd") {
                var holidaysList_1 = JSON.parse(actionFlag.value);
                setHolidays(function (prev) {
                    if (JSON.stringify(prev) === JSON.stringify(holidaysList_1))
                        return prev;
                    return holidaysList_1;
                });
            }
            if (actionFlag.name === "afy-asesor-rolid") {
                setRolAsesorId(actionFlag.value);
            }
        });
    }, [actionFlags]);
    useEffect(function () {
        if (responsePolicyConfirm && (responsePolicyConfirm === null || responsePolicyConfirm === void 0 ? void 0 : responsePolicyConfirm.data)) {
            showToastSuccessMessage("Correo enviado con éxito", typeAlert.success, setSeeToast);
            // El envío recién hecho debe aparecer en el historial de correos
            refetchMailHistory();
            dispatch(policyConfirmClearData());
        }
    }, [responsePolicyConfirm]);
    useEffect(function () {
        if (responsePatchBeneficiary && responsePatchBeneficiary.data) {
            showToastSuccessMessage("Beneficiario actualizado con éxito.", typeAlert.success, setSeeToast);
            setOpenModal(false);
            dispatch(patchBeneficiaryClearData());
            getInsuredBeneficiary();
        }
    }, [responsePatchBeneficiary]);
    useEffect(function () {
        var _a;
        // responsePatchQuote starts as null, becomes `true` while loading,
        // and becomes the payload (with .data) on success. Only react on success.
        if (responsePatchQuote &&
            responsePatchQuote !== true &&
            (responsePatchQuote === null || responsePatchQuote === void 0 ? void 0 : responsePatchQuote.data)) {
            showToastSuccessMessage("Cotización actualizada con éxito.", typeAlert.success, setSeeToast);
            dispatch(patchQuoteClearData());
            callQuoteOne((_a = id !== null && id !== void 0 ? id : quoteId) !== null && _a !== void 0 ? _a : "");
        }
    }, [responsePatchQuote]);
    useEffect(function () {
        if (errorPatchQuote) {
            showToastSuccessMessage("No se pudo actualizar la cotización.", typeAlert.error, setSeeToast);
            dispatch(patchQuoteClearData());
        }
    }, [errorPatchQuote]);
    useEffect(function () {
        if (responsePatchInsured && responsePatchInsured.data) {
            showToastSuccessMessage("Asegurado actualizado con éxito.", typeAlert.success, setSeeToast);
            setOpenModal(false);
            setOpenModalAddInsurance(false);
            // dispatch(person({ enable: true, page: 1, limit: 1000 }));
            dispatch(patchInsuredClearData());
            getInsuredBeneficiary();
        }
    }, [responsePatchInsured]);
    useEffect(function () {
        if (responsePostInsured) {
            showToastSuccessMessage("Asegurado agregado con éxito.", typeAlert.success, setSeeToast);
            dispatch(postInsuredClearData());
            setOpenModal(false);
            setOpenModalAddInsurance(false);
            dispatch(patchInsuredClearData());
            getInsuredBeneficiary();
        }
    }, [responsePostInsured]);
    useEffect(function () {
        if (responseUpdatePerson === null || responseUpdatePerson === void 0 ? void 0 : responseUpdatePerson.data) {
            showToastSuccessMessage("Agregado con éxito.", typeAlert.success, setSeeToast);
            // if (id !== undefined) {
            dispatch(quoteClearData());
            dispatch(quoteOne({ id: id !== null && id !== void 0 ? id : quoteId, fullBody: true }));
            // } else {
            //   dispatch(
            //     quoteOne({
            //       id: quoteId ?? id,
            //       fullBody: true,
            //     }),
            //   );
            // }
            getInsuredBeneficiary();
            dispatch(updatePersonClearData());
        }
    }, [responseUpdatePerson]);
    useEffect(function () {
        if (responseBenefit && (responseBenefit === null || responseBenefit === void 0 ? void 0 : responseBenefit.data)) {
            showToastSuccessMessage("Beneficiario agregado con éxito.", typeAlert.success, setSeeToast);
            setOpenModalBeneficiary(false);
            getInsuredBeneficiary();
            dispatch(benefitClearData());
        }
    }, [responseBenefit]);
    useEffect(function () {
        if (responsePlan && responsePlan.data) {
            /* Payment modes are now loaded from dedicated API - see useEffect for responsePaymentMode */
            /* Filtrar por coverage type */
            var result = filterData(responsePlan.data, "type", catalogConst.CATALOG_BENEFICIARY_TYPE);
            if (result.length > 0) {
                setCoverageType(result);
            }
            /* Filtrar por insured type */
            result = filterData(responsePlan.data, "type", catalogConst.CATALOG_INSURED_TYPE);
            // if (result.length > 0) {
            //   setInsuredType(result);
            //   setDataFormInsurance({
            //     ...dataFormInsurance,
            //     idTypeInsured: result[0].value ?? "",
            //   });
            // }
            /* Filtrar por beneficiary type */
            result = filterData(responsePlan.data, "type", catalogConst.CATALOG_BENEFICIARY_TYPE);
            // if (result.length > 0) {
            //   setBeneficiaryType(result);
            //   setDataFormBeneficiary({
            //     ...dataFormBeneficiary,
            //     idTypeInsured: result[0].value ?? "",
            //   });
            // }
        }
    }, [responsePlan]);
    useEffect(function () {
        var _a, _b, _c, _d, _e;
        if (responseIdentificationType &&
            ((_a = responseIdentificationType.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var idf_1 = [];
            (_b = responseIdentificationType.data) === null || _b === void 0 ? void 0 : _b.map(function (item) {
                idf_1.push({
                    id: item.id,
                    name: item.description ? item.description : "",
                    value: item.id,
                });
            });
            setListIdentificationType(idf_1);
            setDataFormBeneficiary(__assign(__assign({}, dataFormBeneficiary), { IdType: (_c = idf_1[0].value) !== null && _c !== void 0 ? _c : "" }));
            setDataFormInsurance(__assign(__assign({}, dataFormInsurance), { IdType: (_d = idf_1[0].value) !== null && _d !== void 0 ? _d : "" }));
            setDataFormInsuranceSp(__assign(__assign({}, dataFormInsuranceSp), { idType: (_e = idf_1[0].value) !== null && _e !== void 0 ? _e : "" }));
        }
        else {
            //navigate("/customerForm");
        }
    }, [responseIdentificationType]);
    useEffect(function () {
        var _a, _b;
        if (responseCatalogGender && ((_a = responseCatalogGender.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var data = (_b = responseCatalogGender.data) === null || _b === void 0 ? void 0 : _b.map(function (gender) {
                return {
                    id: gender.id,
                    value: gender.id,
                    name: gender.description,
                };
            });
            setListGenders(data);
        }
        else {
            //navigate("/customerForm");
        }
    }, [responseCatalogGender]);
    useEffect(function () {
        var _a, _b;
        if (responseCountries && ((_a = responseCountries.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var data = (_b = responseCountries.data) === null || _b === void 0 ? void 0 : _b.map(function (country) {
                return {
                    id: country.id,
                    value: country.id,
                    name: country.description,
                };
            });
            setListCountries(data);
        }
        else {
            //navigate("/customerForm");
        }
    }, [responseCountries]);
    useEffect(function () {
        var _a;
        if (responseRegion && (responseRegion === null || responseRegion === void 0 ? void 0 : responseRegion.data)) {
            var data = (_a = responseRegion.data) === null || _a === void 0 ? void 0 : _a.map(function (region) {
                return {
                    id: region.id,
                    value: region.id,
                    name: region.name,
                };
            });
            data.unshift({ id: "-1", value: "-1", name: " " });
            if (responseRegion.level === level1) {
                setListRegionLevel1(data);
            }
            else if (responseRegion.level === level2) {
                if (data.length > 0) {
                    setListRegionLevel2(data);
                }
                else {
                    setListRegionLevel2([{ id: "-1", value: "-1", name: " " }]);
                }
            }
            else if (responseRegion.level === level3) {
                if (data.length > 0) {
                    setListRegionLevel3(data);
                }
                else {
                    setListRegionLevel3([{ id: "-1", value: "-1", name: " " }]);
                }
            }
        }
    }, [responseRegion]);
    useEffect(function () {
        if (responseBeneficiary === null || responseBeneficiary === void 0 ? void 0 : responseBeneficiary.data) {
            setBeneficiaryStorybook(responseBeneficiary.data);
        }
    }, [responseBeneficiary === null || responseBeneficiary === void 0 ? void 0 : responseBeneficiary.data]);
    useEffect(function () {
        if (responseInsured === null || responseInsured === void 0 ? void 0 : responseInsured.data) {
            setInsuranceStorybook(responseInsured === null || responseInsured === void 0 ? void 0 : responseInsured.data);
            setSessionData(responseInsured);
        }
    }, [responseInsured]);
    useEffect(function () {
        if (actionFlags.length > 0) {
            getActionFlags();
        }
    }, [actionFlags]);
    // Override Prima in localStorage summary with contentMap.premium when travel insurance
    useEffect(function () {
        var _a, _b;
        if (isTravelInsurance &&
            ((_b = (_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.contentMap) === null || _b === void 0 ? void 0 : _b.premium) != null) {
            addToSummary([
                {
                    label: "Prima",
                    value: "USD ".concat(responseOneQuote.data.contentMap.premium),
                },
            ]);
        }
    }, [isTravelInsurance, (_x = (_w = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _w === void 0 ? void 0 : _w.contentMap) === null || _x === void 0 ? void 0 : _x.premium]);
    useEffect(function () {
        var _a, _b, _c, _d, _e;
        if (!((_a = summary === null || summary === void 0 ? void 0 : summary.data) === null || _a === void 0 ? void 0 : _a.length)) {
            setFilters(defaultFilters);
            return;
        }
        var byLabel = Object.fromEntries(summary.data.map(function (i) { return [i.label, i.value]; }));
        // Orden grupo deseado
        var header = ["Documento", "No. de cotización"];
        var cliente = ["Nombres", "Apellidos"];
        var used = new Set(__spreadArray(__spreadArray([], header, true), cliente, true));
        var producto = summary.data.filter(function (i) { return !used.has(i.label); });
        var out = __spreadArray([
            {
                name: "Número de cotización",
                label: (_b = byLabel["No. de cotización"]) !== null && _b !== void 0 ? _b : "-",
                type: "label",
            },
            {
                name: "Número de documento",
                label: (_c = byLabel["Documento"]) !== null && _c !== void 0 ? _c : "-",
                type: "label",
            },
            // Subtítulo cliente
            {
                name: "Datos del cliente",
                label: "Datos del cliente",
                type: "subtitle",
            },
            { name: "Nombres", label: (_d = byLabel["Nombres"]) !== null && _d !== void 0 ? _d : "-", type: "label" },
            { name: "Apellidos", label: (_e = byLabel["Apellidos"]) !== null && _e !== void 0 ? _e : "-", type: "label" },
            // Subtítulo producto
            {
                name: "Datos del producto",
                label: "Datos del producto",
                type: "subtitle",
            }
        ], producto.map(function (e) {
            var _a, _b, _c, _d;
            var labelValue = e.value;
            if (e.label === "Prima") {
                if (isTravelInsurance &&
                    ((_b = (_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.contentMap) === null || _b === void 0 ? void 0 : _b.premium) != null) {
                    labelValue = "USD ".concat(responseOneQuote.data.contentMap.premium);
                }
                else {
                    labelValue = prime || e.value;
                }
            }
            if (e.label === afy_label_premium) {
                labelValue = prime || e.value;
                e.label =
                    ((_d = (_c = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _c === void 0 ? void 0 : _c.catalogStatusQuote) === null || _d === void 0 ? void 0 : _d.code) !== "G"
                        ? (afy_label_premium !== null && afy_label_premium !== void 0 ? afy_label_premium : "Prima")
                        : "Prima";
            }
            var name = e.label;
            var showChangeButton = isQuoteType &&
                (name === "Plan" ||
                    name === "Modalidad de Pago" ||
                    name === "Tipo de Cobertura");
            return __assign({ name: name, label: labelValue, type: "label" }, (showChangeButton ? { showChangeButton: true } : {}));
        }), true);
        setFilters(out);
    }, [
        summary,
        defaultFilters,
        prime,
        isTravelInsurance,
        (_z = (_y = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _y === void 0 ? void 0 : _y.contentMap) === null || _z === void 0 ? void 0 : _z.premium,
    ]);
    useEffect(function () {
        if (responsePersonByDocument && responsePersonByDocument.length > 0) {
            var dataPerson = responsePersonByDocument[0];
            var updatedDataFormPerson = updateDataFormPerson(dataPerson, isInsurance ? dataFormInsurance : dataFormBeneficiary);
            if (isInsurance) {
                setDataFormInsurance(updatedDataFormPerson);
            }
            else {
                setDataFormBeneficiary(updatedDataFormPerson);
            }
            setTrigger(false);
            dispatch(personByDocumentClearData());
        }
        if ((responsePersonByDocument === null || responsePersonByDocument === void 0 ? void 0 : responsePersonByDocument.length) === 0) {
            if (isInsurance) {
                setDataFormInsurance({
                    Name: "",
                    SecondName: "",
                    LastNameA: "",
                    LastNameB: "",
                    marriedName: "",
                    Birthday: "",
                    PhoneNumber: "",
                });
            }
            else {
                setDataFormBeneficiary({
                    Name: "",
                    SecondName: "",
                    LastNameA: "",
                    LastNameB: "",
                    marriedName: "",
                    Birthday: "",
                    PhoneNumber: "",
                });
            }
            dispatch(personByDocumentClearData());
        }
    }, [responsePersonByDocument, isInsurance, trigger]);
    useEffect(function () {
        setUploadTrigger(false);
        setOpenDrawerUpload(false);
        dispatch(postQuoteUploadDocumentClearData());
        if (id !== undefined) {
            dispatch(quoteClearData());
            callQuoteOne(id);
        }
        else {
            callQuoteOne(quoteId);
        }
        if (responseUploadDocuments) {
            window.dispatchEvent(new CustomEvent("pendingDocumentsChanged"));
        }
    }, [responseUploadDocuments]);
    var deleteInsured = React.useCallback(function (params) {
        var _a;
        var insuredId = (_a = params === null || params === void 0 ? void 0 : params.row) === null || _a === void 0 ? void 0 : _a.id;
        if (!insuredId)
            return;
        dispatch(deleteInsuredAction({
            id: insuredId,
            body: { force: false },
        }));
    }, [dispatch]);
    useEffect(function () {
        var _a;
        if (!responseDeleteInsured && !errorDeleteInsured)
            return;
        if (responseDeleteInsured) {
            dispatch(insured({
                enable: true,
                page: 1,
                limit: 100,
                quoteId: quoteId ? quoteId : id,
            }));
            setSeeToast({
                show: true,
                message: "Asegurado eliminado correctamente.",
                type: typeAlert.success,
            });
        }
        if (errorDeleteInsured) {
            setSeeToast({
                show: true,
                message: (_a = errorDeleteInsured === null || errorDeleteInsured === void 0 ? void 0 : errorDeleteInsured.message) !== null && _a !== void 0 ? _a : "No se pudo eliminar el asegurado. Intente nuevamente.",
                type: typeAlert.error,
            });
        }
        dispatch(deleteInsuredClearData());
    }, [responseDeleteInsured, errorDeleteInsured]);
    var columnsInsurance = Tab1Columns(editInsured, deleteInsured, canEditInsured, rows);
    var columnsBeneficiary = Tab2Columns(editBeneficiary, canEditBeneficiary);
    var callGetInsuredBeneficiary = function (quoteId) {
        var id_ = quoteId;
        if (id_) {
            if (!(responseInsured === null || responseInsured === void 0 ? void 0 : responseInsured.data) && !(responseBeneficiary === null || responseBeneficiary === void 0 ? void 0 : responseBeneficiary.data)) {
                dispatch(getBeneficiary({
                    enable: true,
                    page: 1,
                    limit: 100,
                    quoteId: id_,
                }));
                dispatch(insured({
                    enable: true,
                    page: 1,
                    limit: 100,
                    quoteId: id_,
                }));
            }
        }
    };
    // Passenger Download Modal State
    var _179 = useState(false), openPassengerModal = _179[0], setOpenPassengerModal = _179[1];
    var _180 = useState(false), openModalAddPassenger = _180[0], setOpenModalAddPassenger = _180[1];
    var _181 = useState(""), selectedQuoteId = _181[0], setSelectedQuoteId = _181[1];
    var _182 = useState(null), editingPassengerId = _182[0], setEditingPassengerId = _182[1];
    var _183 = useState(null), editingPassengerData = _183[0], setEditingPassengerData = _183[1];
    var handleAddPassanger = function () {
        setEditingPassengerId(null);
        setEditingPassengerData(null);
        setOpenModalAddPassenger(true);
    };
    var onClickPassangerDownload = React.useCallback(function () {
        setSelectedQuoteId(quoteId);
        setOpenPassengerModal(true);
    }, [quoteId]);
    var handlePassengerModalClose = React.useCallback(function () {
        setOpenPassengerModal(false);
        setSelectedQuoteId("");
    }, []);
    var handleOpenPdf = React.useCallback(function (url, name) {
        setUrlDocumentPassenger(url);
        setNameDocumentPassenger(name);
        setOpenModalPassenger(true);
    }, []);
    var _184 = React.useState(false), triggerAddAppointmentAction = _184[0], setTriggerAddAppointmentAction = _184[1];
    var columnsAppointment = TabAppointmentColumns(false, false);
    var columnsAppointmentManager = TabAppointmentManagerColumns(false, false);
    var _185 = useAppointment((_1 = (_0 = id !== null && id !== void 0 ? id : quoteIdLS) !== null && _0 !== void 0 ? _0 : quoteId) !== null && _1 !== void 0 ? _1 : "", showTabAppointment), appointmentRows = _185.appointmentRows, appointmentId = _185.appointmentId, setAppointmentRows = _185.setAppointmentRows, setExecutiveUserId = _185.setExecutiveUserId, setAppointmentId = _185.setAppointmentId, executiveUserId = _185.executiveUserId, loadingGetAppointmentAction = _185.loadingGetAppointmentAction, callAppointment = _185.callAppointment;
    var _186 = useAppointmentManager(appointmentId, setOpenModalAddAppointmentAction, setTriggerAddAppointmentAction, triggerAddAppointmentAction, showTabAppointmentManager, (_2 = lsLogin.getUserLoginStored().user.id) !== null && _2 !== void 0 ? _2 : "", setSeeToast, holidays, appointmentRows, quoteId, executiveUserId, setAppointmentRows, setAppointmentId, setExecutiveUserId, rolAsesorid, callQuoteOne, (_4 = (_3 = id !== null && id !== void 0 ? id : quoteIdLS) !== null && _3 !== void 0 ? _3 : quoteId) !== null && _4 !== void 0 ? _4 : "", callAppointment), appointmentManagerRows = _186.appointmentManagerRows, handleAddAppointmetAction = _186.handleAddAppointmetAction, handleSubmitAppointmentAction = _186.handleSubmitAppointmentAction, formAppointmentActionProps = _186.formAppointmentActionProps, loadingAppointmentActionPatch = _186.loadingAppointmentActionPatch, loadingAppointmentPost = _186.loadingAppointmentPost, quotePriceLoading = _186.quotePriceLoading;
    var effectiveQuoteId = id ? id : quoteId;
    var loggedUser = lsLogin.getUserLoginStored();
    var loggedUserId = (_7 = (_6 = (_5 = loggedUser.user) === null || _5 === void 0 ? void 0 : _5.id) !== null && _6 !== void 0 ? _6 : loggedUser.userId) !== null && _7 !== void 0 ? _7 : "";
    var loggedUserName = [
        (_9 = (_8 = loggedUser.idToken) === null || _8 === void 0 ? void 0 : _8.payload) === null || _9 === void 0 ? void 0 : _9.name,
        (_11 = (_10 = loggedUser.idToken) === null || _10 === void 0 ? void 0 : _10.payload) === null || _11 === void 0 ? void 0 : _11.family_name,
    ]
        .filter(Boolean)
        .join(" ")
        .trim() || loggedUser.userName;
    var currentCreatorType = "manager";
    var _187 = useQuoteComments({
        quoteId: effectiveQuoteId,
        currentUserId: loggedUserId,
        currentUserName: loggedUserName,
        currentCreatorType: currentCreatorType,
        showComments: showComments,
        setSeeToast: setSeeToast,
        t: t,
    }), quoteComments = _187.comments, loadingPostComment = _187.loadingPostComment, loadingPutComment = _187.loadingPutComment, loadingDeleteComment = _187.loadingDeleteComment, loadingGetComments = _187.loadingGetComments, handleAddComment = _187.addComment, handleUpdateComment = _187.updateComment, handleDeleteComment = _187.deleteComment;
    var _188 = useAuditLogs({
        enable: showLogsInfo && !!effectiveQuoteId,
        page: 0,
        size: 100,
        orderDir: "ASC",
        quoteId: effectiveQuoteId,
        setSeeToast: setSeeToast,
        t: t,
    }), auditLogEntries = _188.logEntries, loadingGetAuditLogs = _188.loadingGetAuditLogs;
    return (_jsxs(React.Fragment, { children: [_jsx(PagesHeader, { titlePage: titleInsured, hideStep: isQuote === "false", steps: steps, completed: isQuote === "false" || isLastPage }), _jsx(ConfirmationHeader, { loading: loadingPostInsured ||
                    loadingUpdatePerson ||
                    loadingOneQuote ||
                    loadingBenefit ||
                    loadingPostInsured ||
                    loadingPatchBeneficiary ||
                    loadingPatchInsured ||
                    loadingPersonByDocument ||
                    loadingOneProject ||
                    loadingBeneficiary ||
                    loading ||
                    loadingPlans ||
                    loadingUpdateQuote ||
                    loadingUploadDocuments ||
                    loadingGetCatalogBeneficiary ||
                    loadingGetCatalogInsurance ||
                    loadingCertificateQuote ||
                    loadingInsured ||
                    loadingPaymentMode ||
                    loadingComplete ||
                    loadingCatalogues ||
                    loadingStartWorkFlow ||
                    loadingPatchQuote ||
                    loadingAppointmentActionPatch ||
                    loadingPostComment ||
                    loadingPutComment ||
                    loadingDeleteComment ||
                    loadingGetComments ||
                    responsePolicyConfirmLoading ||
                    loadingAppointmentPost ||
                    loadingGetAppointmentAction ||
                    quotePriceLoading, text: loadingUpdatePerson || loadingUpdateQuote || loadingPatchQuote
                    ? "Actualizando cotización..."
                    : loadingUploadDocuments
                        ? "Subiendo documento..."
                        : "Cargando...", seeToast: seeToast, showToast: showToast, setSeeToast: setSeeToast }), openPassengerModal && (_jsx(PassengerDownloadModal, { open: openPassengerModal, onClose: handlePassengerModalClose, setSeeToast: setSeeToast, quoteId: selectedQuoteId, onOpenPdf: handleOpenPdf })), showComponent ? (_jsx(Suspense, { children: _jsx(ConfirmationFormView, { onClickPassangerDownload: onClickPassangerDownload, isTravelInsurance: isTravelInsurance, seeToast: seeToast, showToast: showToast, setSeeToast: setSeeToast, breadcrumbs: breadCrumbs, steps: steps, 
                    /* PDF VIEWER DOCUMENT*/
                    openModal: openModalPdfViewer, setOpenModal: setopenModalPdfViewer, documentName: nameDocument, urlDocument: urlDocument, 
                    /* PDF VIEWER CLIENT*/
                    openModalClient: modalDocumentClient, setOpenModalClient: setModalDocumentClient, documentNameClient: docName, urlDocumentClient: urlDocumentClient, 
                    /* PDF VIEWER PASSENGER */
                    openModalPassenger: openModalPassenger, setOpenModalPassenger: setOpenModalPassenger, documentNamePassenger: nameDocumentPassenger, urlDocumentPassenger: urlDocumentPassenger, 
                    /* MODAL EDIT VEHICLE */
                    openModalEditVehicle: openModalEditVehicle, setOpenModalEditVehicle: setOpenModalEditVehicle, dataFormVehicle: dataFormVehicle, callQuoteOneApi: callQuoteOne, quoteId: id ? id : quoteId, planId: planId, coverTypeId: coverTypeId, campaignId: campaignId, catalogPaymentMode: catalogPaymentMode, catalogStatusQuote: catalogStatusQuote, branchId: branchId, userId: userId, idQuoteVehicle: idQuoteVehicle, productId: productId, t: t, planName: planName, productType: productType, projectTypeLocal: projectTypeLocal, salesFlow: salesFlow, 
                    /* MODAL BENEFICIARY */
                    openModalBeneficiary: openModalBeneficiary, setOpenModalBeneficiary: setOpenModalBeneficiary, isMaskedDocument: isMaskedDocument, dataFormBeneficiary: dataFormBeneficiary, titleBeneficiary: titleBeneficiary, beneficiaryType: beneficiaryType, listIdentificationType: listIdentificationType, initialPercentage: initialPercentage, handleSubmitBeneficiary: function () {
                        return handleSubmitBeneficiary(dataFormBeneficiary);
                    }, searchPerson: function (e) {
                        return searchPerson(e, setIsInsurance, setDocument, setTrigger);
                    }, 
                    /* MODAL INSURED */
                    openModalInsured: openModal, setOpenModalInsured: setOpenModal, dataFormInsurance: dataFormInsurance, titleInsured: titleInsured, insuredType: insuredType, handleSubmitInsured: function (data) { return handleSubmitInsured(data); }, searchInsurancePerson: function (e) { return searchInsurancePerson(e); }, 
                    /* MODAL CONFIRMATION */
                    openModalBackConfirm: openModalBackConfirm, handleCloseBackModal: handleCloseBackModal, handleBackFromModal: handleBackFromModal, classes: classes, 
                    /* VIEW */
                    isRequired: !isApap, tabAdditionalDocumentation: "Documentos Clientes", countBadgeContent: countBadge, customBadgeColor: "#fba730", badgeColorText: "#ffffff", additionalDocumentationColumns: AdditionalDocumentationColumns(handleClickContextMenu), additionalDocumentationRows: profileDocumentsRows, hideMarriedName: hideMarriedName, titleDrawer: "Suba el documento solicitado.", descriptionDrawer: "Arrastra el documento solicitado a la zona de color o haz clic en el área de color para seleccionarlo. Solo puedes subir un documento a la vez, y solo se permiten archivos en formato PDF.", titleUpload: "Arrastre y suelte su archivo.", heightDrawer: "100%", disableSelectCountry: true, openDrawerUpload: openDrawerUpload, onCloseDrawer: function () {
                        setOpenDrawerUpload(false);
                    }, onUpload: quoteUploadDocuments, tabAuto: "Auto Asegurado", tabAutoDescription: "", tabStatement: "Estado de cuenta", tabStatementColumns: StatementColumns(t), tabStatementRows: statementRows, TabAutoColumns: TabAutoColumns(updateVehicle, isQuote ? isQuote : ""), TabAutoRows: listVehiclesDetail, onChangeSelect: handleChangeSelect, handleChangeSelectFormInsurance: handleChangeSelectFormInsurance, 
                    // ***--- PROPS BOTONES DESCARGAR QUOTE DESDE RESUMEN
                    onClickAutoDownload: handleOnClickAutoDownload, btnLblDownload: "Descargar Cotización", btnDownloadQuoteBackground: "#ffffff", showButtonDownloadApap: !showVehicleData || !showDownloadQuote, onClickAutoDownloadVida: handleOnClickAutoDownloadVida, btnLblDownloadVida: "Descargar Solicitud", showButtonDownloadVida: !showDownloadRequest, 
                    // ***--- END PROPS BOTONES DESCARGAR QUOTE DESDE RESUMEN
                    labelNumberQuote: "No. de cotización", labelPolicyNumber: ((_12 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _12 === void 0 ? void 0 : _12.policyId) ? "No. de póliza" : undefined, title: "Confirmación de datos", identificationList: listIdentificationType, GenderList: listGenders, CountryList: listCountries, ProvinceList: listRegionLevel1, TownList: listRegionLevel2, SectorList: listRegionLevel3, dataForm: dataForm, hideTabs: [
                        showInsured,
                        showBeneficiary,
                        hideTabPaymentInfo,
                        showVehicleData,
                        true,
                        showDocumentClient,
                        !isTravelInsurance,
                        showTabRealEstates,
                        !showTabAppointment,
                        !showTabAppointmentManager,
                        !showTabReferrer,
                        !showComments,
                        false,
                        !showCardInformation,
                        !policyId, // Tab: Historial de correos - solo en póliza, que es cuando se envían correos
                    ], hideAddButton: [
                        addInsured,
                        addBeneficiary,
                        true,
                        true,
                        !addAppointmentAction,
                    ], showAdd: true, showActions: canEdit, showContactActions: canEditContact, showLocationActions: canEditLocation, showDownloads: showDownloads, onClickDownload: handleDownload, certificates: certificates, dateLabel: isQuote !== null && isQuote === "false"
                        ? "Fecha efectiva"
                        : "Fecha de cotización", downloadsTitle: "Descargas", labelAdd: "Agregar", tab1: "Personas aseguradas", tab1Description: "Asegurados", tab2: "Beneficiarios", tab2Description: "Beneficiarios", tab3: "Información de pago", tab3Description: "", Tab1Columns: columnsInsurance, Tab1Rows: rows, Tab2Columns: columnsBeneficiary, Tab2Rows: rowsBeneficiary, Tab3Columns: Tab3Columns, Tab3Rows: rows2, 
                    // tab card info
                    tabCardInfo: "Información de tarjeta", tabCardInfoDescription: "Datos de la tarjeta ", TabCardInfoColumns: TabCardInfoColumns, TabCardInfoRows: rowsCardInfo, 
                    //Travel Insurance Tab4
                    tab4: "Pasajeros", 
                    /////
                    Tab4Columns: Tab4Columns, Tab4Rows: rowsPassengers, hide2: true, options1: paymentMode, options2: [], options3: campaignInfo, firstSubtitle: "Información de cotización", secondSubtitle: "Información general del cliente", thirdSubtitle: "Información de ubicación", fourthSubtitle: "Información de contacto", plan: ((paymentModelSelected === null || paymentModelSelected === void 0 ? void 0 : paymentModelSelected.id) &&
                        catalogPaymentMode &&
                        paymentModelSelected.id !== catalogPaymentMode) ||
                        (((coverTypeSelected === null || coverTypeSelected === void 0 ? void 0 : coverTypeSelected.id) || (coverTypeSelected === null || coverTypeSelected === void 0 ? void 0 : coverTypeSelected.value)) &&
                            coverTypeId &&
                            ((coverTypeSelected === null || coverTypeSelected === void 0 ? void 0 : coverTypeSelected.id) || (coverTypeSelected === null || coverTypeSelected === void 0 ? void 0 : coverTypeSelected.value)) !==
                                coverTypeId)
                        ? __assign(__assign({}, plan), { id: "" }) : plan, plans: planData.data || [], paymentMethodData: paymentMode, campaignData: campaign, showPaymentMethod: true, showCampaign: true, onClickAdd: handleAddInsured, onClickRowGrid: function () { }, onClickAddBeneficiary: handleAddBeneficiary, filters: filters, titleSelectButton: "Adquirir", previousLabel: "Anterior", nextLabel: !isVidaTermino ? "Siguiente" : "Finalizar", showPrevious: canEdit, nextDisabled: !permissions.create ||
                        !canEdit ||
                        (navigation === null || navigation === void 0 ? void 0 : navigation.canNavigateNext) === false, onBack: onClickBack, onClickSave: handleUpdatePerson, onNext: handleNext, onClickPrevious: handlePrevious, onBlurInput: function () { }, onChangeInput: function () { }, onClickCancel: function () { }, disableDocumentType: true, disableDocumentNumber: true, onChangePaymentMethod: handleOnChangePaymentMethod, onChangeCampaign: handleOnChangeCampaign, onChangeCoverType: handleOnChangeCoverType, onClickAcquire: handleOnClickAcquire, disabledDownloadVida: false, isQuote: isQuote, isPlan: isPlan, openModalAddInsurance: openModalAddInsurance, setOpenModalAddInsurance: setOpenModalAddInsurance, dataFormInsuranceSp: dataFormInsuranceSp, showButtonActivatePolicy: showButtonActivatePolicy, openActivePolicy: openActivePolicy, setOpenActivePolicy: setOpenActivePolicy, policyId: policyId, callQuoteOne: callQuoteOne, onClickAddPassanger: handleAddPassanger, openModalAddPassenger: openModalAddPassenger, setOpenModalAddPassenger: setOpenModalAddPassenger, editingPassengerData: editingPassengerData, handleSavePassenger: function () { }, 
                    //home/business
                    setOpenModalAddBusiness: setOpenModalAddBusiness, openModalAddBusiness: openModalAddBusiness, isCommerce: isCommerce, tab4Description: "", TabRealEstateRows: rowsProperties, dataFormBusiness: dataFormBusiness, damageBackup: damageBackup, insuredProperty: insuredProperty, showFormBusiness: showFormBusiness, openModalAddHome: openModalAddHome, setOpenModalAddHome: setOpenModalAddHome, onSameDirection: onSameDirection, productCode: productCode, planCode: planCode, setDataFormBusiness: setDataFormBusiness, businessShift: businessShift, businessType: businessType, typeConstruction: typeConstruction, 
                    // END home/business
                    //Appoinment
                    tabAppointment: "Cita", tabAppointmentDescription: "Información de Cita", tabAppointmentColumns: columnsAppointment, tabAppointmentRows: appointmentRows, 
                    //AppointmentManager
                    tabAppointmentManager: "Gestiones", tabAppointmentManagerDescription: "Gestiones", tabAppoinmentManagerColumns: columnsAppointmentManager, tabAppointmentManagerRows: appointmentManagerRows, onClickAddAppAction: handleAddAppointmetAction, openModalAddAppointmentAction: openModalAddAppointmentAction, setOpenModalAddAppointmentAction: setOpenModalAddAppointmentAction, handleSubmitAppointmentAction: handleSubmitAppointmentAction, formAppointmentActionProps: formAppointmentActionProps, showBranchSwitcher: !!((_13 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _13 === void 0 ? void 0 : _13.id), branchSwitcherCardTitle: "Sucursal", branchDisplayLabel: branchDisplayLabelForSwitcher, branchOptions: branchSwitcherOptions, selectedBranchId: (_15 = (_14 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _14 === void 0 ? void 0 : _14.branch) !== null && _15 !== void 0 ? _15 : "", branchSwitcherDisabled: !permissions.create || loadingPatchQuote, branchSwitcherLoading: loadingPatchQuote, onBranchChange: handleBranchChange, branchSwitcherModalTitle: "Cambiar sucursal", referrerRows: referrerRows, currentUserId: loggedUserId, currentCreatorType: currentCreatorType, currentUserIsAdmin: false, comments: quoteComments, onAddComment: handleAddComment, onUpdateComment: handleUpdateComment, onDeleteComment: handleDeleteComment, commentsLabels: {
                        title: "Comentarios del expediente",
                        description: "Discusión interna",
                        placeholder: "Escribe un comentario...",
                        send: "Enviar",
                        cancel: "Cancelar",
                        reply: "Responder",
                        edit: "Editar",
                        delete: "Eliminar",
                        save: "Guardar",
                        attach: "Adjuntar",
                        emptyState: "Sin comentarios todavía",
                        inReplyTo: "Respondiendo a",
                        edited: "editado",
                        preview: "Vista previa",
                        download: "Descargar",
                        confirmDelete: "¿Eliminar este comentario?",
                        fileTooLarge: "Archivo demasiado grande",
                        fileTypeNotAllowed: "Tipo de archivo no permitido",
                        contentRequired: "El comentario no puede estar vacío",
                    }, tabLog: "Bit\u00E1cora", tabLogProps: {
                        showLogNumbers: false,
                        logMaxHeight: "220px",
                        tabLogDescription: "Bitácora de eventos.",
                        logEntries: loadingGetAuditLogs
                            ? ["Cargando bitácora..."]
                            : auditLogEntries.length > 0
                                ? auditLogEntries
                                : ["Sin eventos registrados."],
                    }, tabMailHistory: "Historial de correos", tabMailHistoryProps: {
                        mailHistoryItems: mailHistoryItems,
                        mailHistoryCertificate: mailHistoryCertificate,
                        mailHistoryPrintedAt: mailHistoryPrintedAt,
                        mailHistoryEmptyState: loadingMailHistory
                            ? "Cargando historial de correos..."
                            : undefined,
                        onDownloadMailHistoryExcel: function (items) {
                            return downloadMailHistory(items, mailHistoryCertificate, mailHistoryPrintedAt);
                        },
                    }, 
                    //CHANGE PAYMENT METHOD
                    showPaymentMethodCard: !!policyId && policyStatus.toLowerCase() === "activa", filterPaymentMethod: paymentMethodCardData, titlePaymentMethodCard: "Método de pago", onClickChangePaymentMethod: function () {
                        navigate("/checkout/payment-method/".concat(quoteId));
                    }, 
                    // END CHANGE PAYMENT METHOD
                    // sendMail
                    showSendEmailBox: !!policyId, defaultEmail: email, onClickSendEmail: handleSendEmail }) })) : (_jsx("div", {}))] }));
};
export default ConfirmationForm;
